export const aiToolsData = [
  {
    "category": "Latest AI",
    "tools": [
      {
        "name": "HeyGen",
        "url": "https://aixplore.in/tool_details?slug=heygen",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/120.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Abacus AI",
        "url": "https://aixplore.in/tool_details?slug=abacus-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/119.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Meta AI",
        "url": "https://aixplore.in/tool_details?slug=meta-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/118.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Manus",
        "url": "https://aixplore.in/tool_details?slug=manus",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/117.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Ollama",
        "url": "https://aixplore.in/tool_details?slug=ollama",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/116.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Notion",
        "url": "https://aixplore.in/tool_details?slug=notion",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/83.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gamma",
        "url": "https://aixplore.in/tool_details?slug=gamma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/47.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Speechify",
        "url": "https://aixplore.in/tool_details?slug=speechify",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/28.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://aixplore.in/tool_details?slug=openclaw",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/115.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "21st.dev",
        "url": "https://aixplore.in/tool_details?slug=21st-dev",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/114.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Cursor",
        "url": "https://aixplore.in/tool_details?slug=cursor",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/1.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Warp.dev",
        "url": "https://aixplore.in/tool_details?slug=warp",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/4.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Windsurf",
        "url": "https://aixplore.in/tool_details?slug=windsurf",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/5.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lovable.dev",
        "url": "https://aixplore.in/tool_details?slug=lovable",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/8.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Replit",
        "url": "https://aixplore.in/tool_details?slug=replit",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/12.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Emergent",
        "url": "https://aixplore.in/tool_details?slug=emergent",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/13.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Claude",
        "url": "https://aixplore.in/tool_details?slug=claude",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/16.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemini",
        "url": "https://aixplore.in/tool_details?slug=gemini",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/18.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Perplexity.ai",
        "url": "https://aixplore.in/tool_details?slug=perplexity",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/19.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "n8n.io",
        "url": "https://aixplore.in/tool_details?slug=n8n",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/20.png",
        "description": "Leading platform for Latest AI.",
        "pricing": "Not Specified",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Brain2Qwerty v2",
        "url": "https://aixplore.in/tool_details?slug=brain2qwerty-v2",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/brain2qwerty-v2.png",
        "description": "A research project that uses AI to convert your brain activity into readable text, without implants or surgery. This experimental technology could one day help paralyzed people communicate more easily, but for now it remains limited to highly controlled laboratory settings",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Sakana Fugu",
        "url": "https://aixplore.in/tool_details?slug=sakana-fugu",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sakana-fugu.png",
        "description": "Orchestrate multiple AI models behind a single OpenAI-compatible API. Fugu selects and combines the right agents (coding, science, long-term context, security, etc.) in real time. It also offers a highly optimized variant for multi-step search and scoring",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "SuperIntern",
        "url": "https://aixplore.in/tool_details?slug=superintern",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/superintern.png",
        "description": "Deploy an \u201cAI intern\u201d connected to your emails, calendar, and chats to take the burden off your administrative workload. The agent follows conversations, takes real-time notes during meetings (without using a bot), retrieves links and decisions, answers frequently asked questions, and briefs you every morning",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Diaform",
        "url": "https://aixplore.in/tool_details?slug=diaform",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/diaform.png",
        "description": "Replace your static forms with AI-powered interviews that really dig into the answers. The agent leads the conversation, asks follow-up questions, summarizes each interview, and automatically generates actionable insights. Ideal for your products, churn surveys, or onboarding feedback (without the team having to read through everything)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Wery.AI",
        "url": "https://aixplore.in/tool_details?slug=wery-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wery-ai.png",
        "description": "Set a goal, review the proposed action plan, and then let a team of dedicated AI agents carry out each step autonomously and in a coordinated manner. Whether it\u2019s creative content, automation, research, or slide generation, every need is handled by an AI expert",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Dedoctive",
        "url": "https://aixplore.in/tool_details?slug=dedoctive",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dedoctive.png",
        "description": "Base your decisions on traceable answers linked to verified sources and reviewed by your teams. Analyze complex topics with greater rigor, transparency, and confidence",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Figma Motion",
        "url": "https://aixplore.in/tool_details?slug=figma-motion",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/figma-motion.png",
        "description": "Animate your interfaces directly in Figma, without using After Effects or any other tool. Create professional animations using an AI agent that adjusts each keyframe and can reuse animation styles. You can export to code (CSS, JSON, React) or MP4/GIF",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "PaioClaw",
        "url": "https://aixplore.in/tool_details?slug=paioclaw",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/paioclaw.png",
        "description": "Host your private OpenClaw agents in less than a minute, without Docker or the command line. You get an AI assistant that\u2019s always available in a secure environment, with Claws preconfigured for specific business roles. It features thousands of skills and an optimization layer (reducing your token costs)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CinLink",
        "url": "https://aixplore.in/tool_details?slug=cinlink",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/cinlink.png",
        "description": "Edit and repurpose your videos using natural language. Simply dictate what you want (subtitles, translation, dubbing, clips, summaries), and the platform generates workflows, clips, and multilingual versions without the need for a complex timeline",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "FlowSpeech",
        "url": "https://aixplore.in/tool_details?slug=flowspeech",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/flowspeech.png",
        "description": "Convert text, images, or PDF files into natural-sounding human voices. This TTS studio lets you control emotions, pauses, and pacing, with over 30 voices to choose from. Great for creating voiceovers or podcasts",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "ImaginPrompt",
        "url": "https://aixplore.in/tool_details?slug=imaginprompt",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/imaginprompt.png",
        "description": "Analyze any image to get the exact prompt to use in Midjourney, Nano Banana, or ChatGPT Image. Upload an image: the AI will analyze its style, lighting, and composition, then generate prompts that are ready to copy",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "iSummarizer",
        "url": "https://aixplore.in/tool_details?slug=isummarizer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/isummarizer.png",
        "description": "Summarize your texts and get quick answers with easy-to-use AI. This website offers tools for condensing articles and documents, as well as an \u201cAsk AI\u201d feature that provides a single, clear answer to your question (without a conversation)",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Mistral Small 4",
        "url": "https://aixplore.in/tool_details?slug=mistral-small-4",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mistral-small-4.png",
        "description": "This open-source model combines reasoning, image analysis, and advanced coding into a single tool. Powerful and flexible, it can handle long queries and generate more direct and effective responses. A robust alternative to the best models on the market",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "A2E AI",
        "url": "https://aixplore.in/tool_details?slug=a2e-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/a2e-ai.png",
        "description": "A powerful video studio that combines image-to-video generator, talking avatars, face swap, lip sync, and voice cloning all in one place. Great for testing multiple models uncensored and quickly creating a wide range of clips",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "MysticX.AI",
        "url": "https://aixplore.in/tool_details?slug=mysticx-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mysticx-ai.png",
        "description": "Get an instant tarot reading powered by AI. You choose a spread (love, career, yes/no, choosing between two paths), and the AI interprets the cards to guide you on your everyday questions",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Personal Computer Perplexity",
        "url": "https://aixplore.in/tool_details?slug=personal-computer-perplexity",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/personal-computer-perplexity.png",
        "description": "Describe a goal, and this cloud agent orchestrates 19 AI models in parallel to plan, search, code, and deliver the complete result. Sub-agents work in the background without requiring your presence",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Legora",
        "url": "https://aixplore.in/tool_details?slug=legora",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/legora.png",
        "description": "This platform helps lawyers review contracts, draft documents, and conduct research using verified sources. It centralizes collaboration between law firms and clients with SOC2/ISO27001 security",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CreatOK",
        "url": "https://aixplore.in/tool_details?slug=creatok",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/creatok.png",
        "description": "A generator designed to quickly produce short videos ready for TikTok, Reels, or Shorts. Scripts, visuals, voices, and editing are all linked together in the same workflow for faster publishing",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Creen AI",
        "url": "https://aixplore.in/tool_details?slug=creen-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/creen-ai.png",
        "description": "Generate images and videos from text using models such as Wan, Seedream, Sora, and Veo3. You can also convert your photos into 1080p videos, edit 4K images, and download everything without watermarks",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Baby Generator",
        "url": "https://aixplore.in/tool_details?slug=ai-baby-generator",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-baby-generator.png",
        "description": "Discover what your future child might look like from two photos. Choose the gender, age, or even twins, then get a realistic portrait in seconds",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Pet Video",
        "url": "https://aixplore.in/tool_details?slug=pet-video",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pet-video.png",
        "description": "Easily turn a photo of your pet into an animated video, perfect for social media (like TikTok or Instagram). AI animates your pet with natural movements in seconds",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "ImagineArt",
        "url": "https://aixplore.in/tool_details?slug=imagineart",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/imagineart.png",
        "description": "Generate HD images and videos from a single interface. Choose from 90+ artistic styles and models such as Nano Banana 2 or Kling AI. You can also train your own custom AI model to create consistent characters",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Wondershare Dr.Fone",
        "url": "https://aixplore.in/tool_details?slug=wondershare-dr-fone",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/03/drfone-favicon.png",
        "description": "A toolkit for recovering data, transferring a phone, repairing iOS or Android, and unlocking certain smartphones. WhatsApp, backups, and changing phones are also supported",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "LoRA AI",
        "url": "https://aixplore.in/tool_details?slug=lora-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lora-ai.png",
        "description": "Create high-end images and cinematic videos using multiple premium templates in one place. You can also train your own model and sell your creations through an integrated marketplace",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Video Converter",
        "url": "https://aixplore.in/tool_details?slug=video-converter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/video-converter.png",
        "description": "Convert your videos between all common formats (MP4, AVI, MKV, MOV, GIF, etc.) right in your browser. You can convert files in batches, export audio files, and automatically delete files",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemini 3.1 Flash-Lite Browser",
        "url": "https://aixplore.in/tool_details?slug=gemini-3-1-flash-lite-browser",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemini-3-1-flash-lite-browser.png",
        "description": "This interactive demo from Google generates complete web pages in real time from a simple text prompt, with near-instant rendering thanks to the model's 360 tokens per second. You can watch the interface build in real time, making it ideal for quickly creating UI mockups or simulating apps",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "DeerFlow",
        "url": "https://aixplore.in/tool_details?slug=deerflow",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/03/deerflow-logo.png",
        "description": "An open-source project by ByteDance designed to search, code, and produce content using multiple coordinated sub-agents. Its memory management, sandbox, extensible tools, and skills system enable it to handle longer and more complex tasks",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Voxtral TTS",
        "url": "https://aixplore.in/tool_details?slug=voxtral-tts",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/voxtral-tts.png",
        "description": "A lightweight text-to-speech model (4 billion parameters) capable of generating realistic and expressive speech in 9 languages, with support for various dialects. Available via API and can be tested directly in the studio",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Trainn AI",
        "url": "https://aixplore.in/tool_details?slug=trainn-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/trainn-ai.png",
        "description": "A platform for training your customers using videos, interactive guides, and a knowledge base. Record a single product demo, then quickly roll out tutorials, an online academy, or e-learning courses",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Uni-1 by Luma",
        "url": "https://aixplore.in/tool_details?slug=uni-1-by-luma",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/uni-1-by-luma.png",
        "description": "A visual generator capable of thinking before creating, producing images that are more coherent and easier to direct. Multiple references, guided editing, and excellent style control make it more precise than many alternatives",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Accio work",
        "url": "https://aixplore.in/tool_details?slug=accio-work",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/accio-work.png",
        "description": "This AI-powered business tool automates your sourcing, product design, trend analysis, and marketing tasks to quickly turn your ideas into profitable ventures. It also helps you connect more quickly with verified sellers across multiple marketplaces",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw Watermark Remover",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-watermark-remover",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/03/hitpaw-watermark-remover-logo.png",
        "description": "Save time by removing watermarks and logos from your videos directly in your browser. AI analyzes and reconstructs each frame to deliver professional-quality results. It can also handle distracting objects and produces a crisp, blur-free image",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "EZTrimmer",
        "url": "https://aixplore.in/tool_details?slug=eztrimmer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/eztrimmer.png",
        "description": "Need to trim a video for TikTok or social media? This online tool processes your files quickly without adding a watermark. It supports MP4, AVI, MOV, MKV, and WebM, with fast export while maintaining quality",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Motionode",
        "url": "https://aixplore.in/tool_details?slug=motionode",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/motionode.png",
        "description": "A project plan generator that transforms a brief, SOW, or PRD into a client proposal ready to send. Timelines, team workload, deliverables, and the impact of changes are automatically calculated using artificial intelligence",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Make infographic AI",
        "url": "https://aixplore.in/tool_details?slug=make-infographic-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/make-infographic-ai.png",
        "description": "Generate timelines, diagrams, charts, and visual summaries from plain text. The tool effortlessly converts your content into clear, well-organized infographics",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Audio Cut",
        "url": "https://aixplore.in/tool_details?slug=audio-cut",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/audio-cut.png",
        "description": "Easily trim your MP3, WAV, AAC, or FLAC audio files directly in your browser. No installation, processing takes just a few seconds",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VOID Netflix",
        "url": "https://aixplore.in/tool_details?slug=void-netflix",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/void-netflix.png",
        "description": "Remove an object from a video, and the AI automatically recalculates the resulting chain of physical interactions: falls, collisions, and altered trajectories. Developed by Netflix, this research model produces results that are far more consistent than current video removal tools",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Atomic Bot",
        "url": "https://aixplore.in/tool_details?slug=atomic-bot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/atomic-bot.png",
        "description": "A personal assistant ready to run 24/7 on your computer or in the cloud, with no need for a dedicated device or complicated setup. It can manage your emails, calendar, and documents, and automate your web tasks through simple conversation. Compatible with Claude, GPT, and Gemini",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Graswald AI",
        "url": "https://aixplore.in/tool_details?slug=graswald-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/graswald-ai.png",
        "description": "A visual studio designed for fashion brands that creates product shots, lookalike photos, lookbooks, and videos without traditional photo shoots. Its true strength lies in its ability to ensure brand consistency at scale, thanks to carefully controlled avatars, poses, and lighting",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Nexscope",
        "url": "https://aixplore.in/tool_details?slug=nexscope",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/nexscope.png",
        "description": "A suite of specialized AI agents designed to help you sell on Amazon: product listing optimization, niche research, competitive intelligence, customer review analysis, advertising data, and marketing content creation. Each agent has a specific role to cover your entire e-commerce workflow",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "PikaStream 1.0",
        "url": "https://aixplore.in/tool_details?slug=pikastream-1-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pikastream-1-0.png",
        "description": "Give your AI agent a face, a voice, and a memory so it can participate in your Google Meet video conferences in real time. It sees, hears, adapts on the fly, and can even perform tasks during the call",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Trinity-Large-Thinking",
        "url": "https://aixplore.in/tool_details?slug=trinity-large-thinking",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/trinity-large-thinking.png",
        "description": "This open-source 400B-parameter model thinks before responding to handle long and complex prompts. It ranks just behind Claude Opus 4.6 on PinchBench and costs 96% less (Apache 2.0 license)",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lorka",
        "url": "https://aixplore.in/tool_details?slug=lorka",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lorka.png",
        "description": "Access GPT, Claude, Gemini, Grok, DeepSeek, and Perplexity all in one interface without having to juggle multiple subscriptions. Compare responses from multiple models side by side and use built-in tools such as image editing, web search, PDF chat, and translation",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Clico",
        "url": "https://aixplore.in/tool_details?slug=clico",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/clico_logo.webp",
        "description": "This AI assistant integrates into every text field in your browser (Gmail, Notion, Slack, LinkedIn, etc.) to help you write, reply, rephrase, or dictate instantly. You stay in the same context without switching tabs or copying and pasting. Available via a Chrome extension",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "FlowchartAI",
        "url": "https://aixplore.in/tool_details?slug=flowchartai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/flowchartai.png",
        "description": "Instantly convert text or images into professional flowcharts using AI. No design skills are required to create diagrams, mind maps, UML Diagrams or Gantt Charts. Editing, exporting, and collaborative sharing features are also available",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CodingPlanX AI",
        "url": "https://aixplore.in/tool_details?slug=codingplanx-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/codingplanx-ai.png",
        "description": "Access over 600 AI models (Claude, GPT, Gemini, DeepSeek) using a single OpenAI-compatible API key. The tool intelligently routes your requests to reduce costs and works natively with Cursor, Cline, and Claude Code",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Sportbot AI",
        "url": "https://aixplore.in/tool_details?slug=sportbot-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sportbot-ai.png",
        "description": "Analyze matches in real time with statistics on team form, head-to-head records, and odds from multiple bookmakers. The tool identifies market inefficiencies to help you make more informed decisions, without ever providing direct predictions",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Instaposts AI",
        "url": "https://aixplore.in/tool_details?slug=instaposts-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/instaposts-ai.png",
        "description": "Create professional carousels for LinkedIn and Instagram in just one step. The tool generates editable posts in feed, Stories, Reels, and carousel formats. All posts are optimized to boost engagement",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Spark 2.0",
        "url": "https://aixplore.in/tool_details?slug=spark-2-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/spark-2-0.png",
        "description": "An open-source engine based on Three.js for displaying Gaussian Splatting 3D worlds with over 100 million vertices in any browser. Accessible on desktop, mobile, and VR headsets (no plugins or installation required)",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Video Summarizer",
        "url": "https://aixplore.in/tool_details?slug=ai-video-summarizer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-video-summarizer.png",
        "description": "Paste a YouTube link or upload your video file to get a structured summary, a full transcript, subtitles, and clickable chapters in seconds. Nine different summary styles cover lectures, meetings, podcasts, and interviews",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Dageno AI",
        "url": "https://aixplore.in/tool_details?slug=dageno-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dageno-ai.png",
        "description": "Analyze how your brand appears in responses from ChatGPT, Perplexity, Gemini, and other AI systems, then boost your visibility with GEO + SEO recommendations. The platform analyzes mentions, citations, traffic, backlinks, and sentiment to turn your data into concrete marketing actions",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AdsCreator.com",
        "url": "https://aixplore.in/tool_details?slug=adscreator-com",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/adscreator-com.png",
        "description": "Generate ad creatives ready for Meta, Google, Stories, and Reels from a single URL. AI automatically extracts your colors, fonts, brand tone, and creates dozens of on-brand variations in seconds",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Pascal Editor",
        "url": "https://aixplore.in/tool_details?slug=pascal-editor",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pascal-editor.png",
        "description": "A completely free, open-source 3D editor for designing house plans, rooms, floor plans, and roofs directly in your browser, with no installation required",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AIR by Revolut",
        "url": "https://aixplore.in/tool_details?slug=air-by-revolut",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/air-by-revolut.png",
        "description": "Manage your finances using natural language, right in the Revolut app. This AI assistant analyzes your spending, tracks your investments, manages your subscriptions, blocks a lost card, and helps you plan your trips (budget, eSIM) with just a few messages",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw AI Video Generator",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-ai-video-generator",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/hitpaw-AI-Video-Generator.webp",
        "description": "Create videos from text or images for free, online, with no sign-up or ads. AI animates your scenes, adds artistic styles and cinematic effects, and exports in up to 4K directly from your browser",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Google Finance AI",
        "url": "https://aixplore.in/tool_details?slug=google-finance-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/google-finance-ai.png",
        "description": "Track your stocks, cryptocurrencies, and markets in real time with AI-powered visualizations and charts that summarize financial news based on your interests. A conversational search bar lets you ask questions about any security and explore historical data",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Shopify AI Toolkit",
        "url": "https://aixplore.in/tool_details?slug=shopify-ai-toolkit",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/05/shopify-fav.webp",
        "description": "Connect your AI tools (Claude Code, Cursor, Windsurf, etc.) directly to the Shopify platform via MCP plugins to create apps, validate code, and manage your store using natural language. Documentation, API schemas, and validation are built-in so that the agent never has to make assumptions",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GLM 5.1",
        "url": "https://aixplore.in/tool_details?slug=glm-5-1",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/glm-5-1.png",
        "description": "This open-weight model, with 754 billion parameters, is designed for long and complex engineering tasks: it can operate autonomously for up to 8 hours straight, from planning through to final delivery. As the world\u2019s first open-source model on WE-Bench Pro and NL2Repo, it rivals Claude Opus 4.6 in code quality",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Fashion Diffusion",
        "url": "https://aixplore.in/tool_details?slug=fashion-diffusion",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/fashion-diffusion.png",
        "description": "In just a few seconds, turn a photo of a garment into a professional-quality image on a mannequin, without needing a studio or a model. The AI automatically detects the contours of the fabric and can even adapt to hand-drawn sketches",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HappyHorse-1.0",
        "url": "https://aixplore.in/tool_details?slug=happyhorse-1-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/HappyHorse-logo.webp",
        "description": "This 15-billion-parameter video model (developed by Alibaba) took first place in the Artificial Analysis rankings for video generation, ahead of Seedance 2.0. It generates text-to-video and image-to-video clips in 1080p with lip-sync in seven languages, all within a single unified pipeline",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Grok Voice Think Fast 1.0",
        "url": "https://aixplore.in/tool_details?slug=grok-voice-think-fast-1-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/grok-voice-logo.png",
        "description": "Handle entire customer calls using a real-time voice model capable of processing in the background without adding latency. This model ranks number one on the \u03c4-voice Bench and is already being used by Starlink",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "ChatGPT Images 2.0",
        "url": "https://aixplore.in/tool_details?slug=chatgpt-images-2-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/chatgpt-images-2-0.png",
        "description": "Generate and edit highly detailed images with perfectly legible text, complex layouts (posters, infographics, UI), and photorealistic rendering. Accessible via ChatGPT or the gpt-image-2 API",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Zawa AI",
        "url": "https://aixplore.in/tool_details?slug=zawa-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/zawa-ai.png",
        "description": "Turn a simple idea into a complete brand identity \u2014 from logos and product photography to social media content, posters, and campaign assets",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HubSpot AEO",
        "url": "https://aixplore.in/tool_details?slug=hubspot-aeo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hubspot-aeo.png",
        "description": "Track in real time how your business is mentioned by AI engines like ChatGPT, Gemini, or Perplexity using a clear, structured dashboard. Ideal for marketing teams, this tool provides an AI visibility score and actionable recommendations to help your business become the go-to answer for AI assistants",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CalBye AI",
        "url": "https://aixplore.in/tool_details?slug=calbye-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/calbye-ai.png",
        "description": "Take a photo of your meals, and the AI instantly calculates calories, macros, and nutritional value. Get personalized tips for weight loss, muscle gain, or balanced nutrition, without the hassle of manual data entry.",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Go Humanize AI",
        "url": "https://aixplore.in/tool_details?slug=go-humanize-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/go-humanize-ai.png",
        "description": "This tool analyzes and rewrites AI-generated text to give it a natural, fluid, and human-like style. Make your AI text undetectable by ZeroGPT, GPTZero, Originality.ai, or Turnitin using a rewriter that transforms robotic-sounding text into natural language",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Browser Harness",
        "url": "https://aixplore.in/tool_details?slug=browser-harness",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/browser-harness.png",
        "description": "In just a few lines, add a self-healing browser \u201charness\u201d that gives an LLM full control over Chrome via the CDP. It can then click, scroll, fill out forms, and adapt to changes in the DOM without having to recode your automations",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "KiloClaw",
        "url": "https://aixplore.in/tool_details?slug=kiloclaw",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/kiloclaw.png",
        "description": "Deploy a fully managed OpenClaw agent in less than a minute, connected to over 500 chat models and 50 chat platforms, with scheduled tasks, enterprise-grade security, and zero DevOps to manage",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Kimi K2.6",
        "url": "https://aixplore.in/tool_details?slug=kimi-k2-6",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/kimi-k2-6.png",
        "description": "This open-source model takes agent-based programming even further with multi-file editing, 256K of context, and the generation of animated front-end interfaces. It also features swarms of up to 300 sub-agents capable of performing tasks continuously",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AIKissfiy",
        "url": "https://aixplore.in/tool_details?slug=aikissfiy",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/aikissfiy.png",
        "description": "Quickly turn your photos into romantic HD kissing videos, ready to share on TikTok, Instagram, or YouTube. Powered by an AI engine that animates faces and adds cinematic effects",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Grok 4.3",
        "url": "https://aixplore.in/tool_details?slug=grok-4-3",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/grok-4-3.png",
        "description": "The new beta version of the xAI model, which is comparable in size to Grok 4.20 but features an improved architecture and knowledge updated through December 2025, is already being rolled out gradually",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Anijam AI",
        "url": "https://aixplore.in/tool_details?slug=anijam-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/anijam-ai.png",
        "description": "Let an AI agent manage the entire animation process, from the script to the final scenes, ensuring consistent character behavior, lip sync, and timeline editing. You describe the story; the platform handles the video animation",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "XCrawl",
        "url": "https://aixplore.in/tool_details?slug=xcrawl",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/xcrawl.png",
        "description": "Manage all your web data extraction tasks in a single tool. This service automates website crawling and scraping, and organizes the data into clean tables. It can also export everything directly to your analytics tools without you having to write any code",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GPT\u20115.5 Instant",
        "url": "https://aixplore.in/tool_details?slug=gpt-5-5-instant",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gpt---5-5-instant.png",
        "description": "Use a more reliable and accurate ChatGPT. This new model significantly reduces hallucinations on sensitive topics (medicine, law, finance). It provides shorter responses and offers greater personalization based on your files, past conversations, and connected Gmail account",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Seed3D 2.0",
        "url": "https://aixplore.in/tool_details?slug=seed3d-2-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/seed3d-2-0.png",
        "description": "An AI-powered 3D modeling platform developed by ByteDance that can generate detailed visual assets from simple descriptions or images. This model generates high-resolution geometry, breaks objects down into articulated parts, and manages the entire scene",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GeniLoop",
        "url": "https://aixplore.in/tool_details?slug=geniloop",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/geniloop.png",
        "description": "An all-in-one design studio for creating videos and images online. Turn text or photos into multi-shot videos, animate characters in anime styles, and add visual effects using the latest AI models (Kling, Wan, GPT Image 2.0, Grok Imagine, etc.)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw Photo Restoration",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-photo-restoration",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/05/hitpaw-photo-restauration-logo.webp",
        "description": "Bring your old, damaged photos back to life right from your browser. This AI tool removes scratches, noise, and blur, restores damaged faces, restores color to black-and-white photos, and converts them to 4K",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Mistral Medium 3.5",
        "url": "https://aixplore.in/tool_details?slug=mistral-medium-3-5",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mistral-medium-3-5.png",
        "description": "Power up your code agents with a 128-billion-parameter model featuring a 256,000-token context window, which excels at coding, reasoning, and following instructions. This model requires only 4 GPUs to run and achieves a score of 77.6% on SWE-Bench Verified",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Video Translator",
        "url": "https://aixplore.in/tool_details?slug=ai-video-translator",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/05/aivideotranslator-logo.png",
        "description": "Translate your videos for free into over 30 languages with AI dubbing, automatic subtitles, and lip-sync. It offers high accuracy, and the average processing time is 3 minutes",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "OfoxAI",
        "url": "https://aixplore.in/tool_details?slug=ofoxai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ofoxai.png",
        "description": "Access GPT-5.4, Claude Opus 4.6, Gemini 3.1, and over 100 large language models (LLMs) through a single API key compatible with OpenAI, Claude, and Gemini. Enjoy ultra-fast global routing (300 ms), shared billing for teams, and support for OpenClaw",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Live Swap",
        "url": "https://aixplore.in/tool_details?slug=live-swap",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/05/liveswap-logo.webp",
        "description": "Swap your face live via your webcam with a latency of less than 500 ms; compatible with OBS, Streamlabs, Zoom, and all streaming software. Perfect for creating AI avatars or hiding your appearance in real time",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VideoAI",
        "url": "https://aixplore.in/tool_details?slug=videoai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/videoai.png",
        "description": "Turn text or images into HD videos featuring talking avatars, AI-generated voices in 140 languages, and automatically generated subtitles. The tool quickly generates clips for marketing, tutorials, or social media",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "hiData.ai",
        "url": "https://aixplore.in/tool_details?slug=hidata-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hidata-ai.png",
        "description": "Ask questions in plain language to clean your data, merge tables, run analyses, and generate charts or presentations. With end-to-end encryption to protect your information",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Vimi",
        "url": "https://aixplore.in/tool_details?slug=vimi",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vimi.png",
        "description": "Turn your photos into short videos ranging from 5 to 30 seconds: upload a portrait, a memory, or a photo, choose a style, and the AI will generate a smooth video ready to share on social media",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemini Omni",
        "url": "https://aixplore.in/tool_details?slug=gemini-omni",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemini-omni.png",
        "description": "Generate, edit, and extend videos from simple text or multimodal prompts using Google\u2019s most advanced video model, integrated into the Gemini suite",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HY World 2.0",
        "url": "https://aixplore.in/tool_details?slug=hy-world-2-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hy-world-2-0.png",
        "description": "Generate interactive 3D environments from text, images, or videos using this open-source model from Tencent. Unlike simple videos, it produces true editable 3D assets (meshes, point clouds) that are directly compatible with Unity and Unreal Engine",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Wondershare Repairit",
        "url": "https://aixplore.in/tool_details?slug=wondershare-repairit",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wondershare-repairit.png",
        "description": "Easily repair your corrupted videos, photos, audio files, and documents with this AI tool. Whether online or using the desktop software, you can also restore damaged files, colorize old black-and-white photos, and upscaling the quality of your media",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "EchoTik",
        "url": "https://aixplore.in/tool_details?slug=echotik",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/echotik.png",
        "description": "Analyze the TikTok market to boost your e-commerce sales. The platform offers a comprehensive dashboard to identify top-performing products, follow influencers, monitor the competition, and review live video statistics",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "ArchyBase",
        "url": "https://aixplore.in/tool_details?slug=archybase",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/archybase.png",
        "description": "Turn your sketches, floor plans, or raw photos into photorealistic 4K renderings for architecture. This tool helps you visualize interiors, exteriors, and gardens in different styles to impress your clients or enhance your real estate listings",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Iridea",
        "url": "https://aixplore.in/tool_details?slug=iridea",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/iridea.png",
        "description": "Create ad campaigns that stay true to your brand identity. This AI content engine analyzes your website and brief to instantly generate text and visuals tailored for Meta, Instagram, and other social media platforms",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Keyapi",
        "url": "https://aixplore.in/tool_details?slug=keyapi",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/keyapi.png",
        "description": "Unify your social media and e-commerce data with a single API. Designed to feed your AI agents or automations, it connects to over 20 different platforms and delivers ready-to-use JSON data (with a single authentication key)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VibeKnow Studio",
        "url": "https://aixplore.in/tool_details?slug=vibeknow-studio",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vibeknow-studio.png",
        "description": "Turn your text, documents, or web links into explainer videos and dynamic presentations. AI automatically generates the script, scenes, voice-over, and subtitles, giving you a complete video draft in just a few minutes",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Soleads",
        "url": "https://aixplore.in/tool_details?slug=soleads",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/soleads.png",
        "description": "Quickly extract qualified leads from Instagram, LinkedIn, TikTok, or Google Maps without writing a single line of code. The tool retrieves email addresses, phone numbers, and public profiles, then lets you export clean lists in CSV or Excel format",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "ComicInk",
        "url": "https://aixplore.in/tool_details?slug=comicink",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/comicink.png",
        "description": "Create a complete comic book from a simple idea or script. The AI generates characters with consistent visuals from page to page, draws speech bubbles, panels, and the cover. You can export the entire project in various formats",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Dumble",
        "url": "https://aixplore.in/tool_details?slug=dumble",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dumble.png",
        "description": "Create websites, apps, and documents using a no-code development environment. Powered by AI that acts as a co-pilot to guide you from concept to finished product",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "TonesMatch",
        "url": "https://aixplore.in/tool_details?slug=tonesmatch",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/tonesmatch.png",
        "description": "Find the guitar sound from a song and tailor it to your own gear. You select a song, your guitar, and your amp, and the AI analyzes a database of 13,000 sounds to give you precise settings for tone, pedals, and pickups",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Aleph 2.0",
        "url": "https://aixplore.in/tool_details?slug=aleph-2-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/aleph-2-0.png",
        "description": "Edit your videos with frame-by-frame precision: change the color, clothing, or background in a single frame, and the AI will apply the edit to the entire sequence. Editing is possible for clips up to 30 seconds long in 1080p, without altering the parts you haven\u2019t edited",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Claude Opus 4.8",
        "url": "https://aixplore.in/tool_details?slug=claude-opus-4-8",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/claude-opus-4-8.png",
        "description": "Take advantage of Anthropic\u2019s AI model\u2014more reliable, more honest, and four times less likely to overlook its own errors. Its fast mode delivers up to 2.5 times more tokens per second (at the same API rate as the previous version)",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VmakeAI",
        "url": "https://aixplore.in/tool_details?slug=vmakeai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vmakeai.png",
        "description": "Turn a product link, photo, or idea into UGC videos that are ready to drive conversions. The tool combines AI-powered avatar generation, automatic captions, up to 4K upscaling, background removal, and visual optimization into a single workflow designed for TikTok, Reels, and Shopify",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "PettiChat",
        "url": "https://aixplore.in/tool_details?slug=pettichat",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/06/pettichat-logo.webp",
        "description": "A small, 27-gram smart collar that claims to translate your dog or cat\u2019s sounds into human language in real time. The AI, trained on 1.5 million audio samples, sends an interpretation to the mobile app in less than 1.2 seconds, with built-in GPS tracking",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "IG Comments Scraper",
        "url": "https://aixplore.in/tool_details?slug=ig-comments-scraper",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/06/IG-Comment-logo.webp",
        "description": "Export all comments from an Instagram post to Excel or CSV with a single click. This Chrome extension automatically collects the text, author, date, and profile photo to provide you with a file you can use for your analytics or marketing campaigns",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Couplelens",
        "url": "https://aixplore.in/tool_details?slug=couplelens",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/couplelens.png",
        "description": "Turn your couple photos into stylized works of art and short video keepsakes. Choose a visual style (romantic, wedding, or painted portraits) and capture your most beautiful moments digitally",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Image To Video AI Free",
        "url": "https://aixplore.in/tool_details?slug=image-to-video-ai-free",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/image-to-video-ai-free.png",
        "description": "Turn a simple image into an animated video clip ready for social media. Upload a photo, describe the style you want, and the AI automatically generates a short, dynamic video with camera movements and transitions",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Coralflavor Unfiltered AI",
        "url": "https://aixplore.in/tool_details?slug=coralflavor-unfiltered-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/coralflavor-unfiltered-ai.png",
        "description": "Chat freely with an AI without any filters in a private space. Ask questions without restriction, explore sensitive topics, or engage in creative roleplay. Strong emphasis on privacy",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "TeachQuill",
        "url": "https://aixplore.in/tool_details?slug=teachquill",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/teachquill.png",
        "description": "A comprehensive AI toolkit to save time in the classroom. With just a few clicks, you can generate lesson plans, exercises, quizzes, assessment rubrics, and IEP goals, using over 60 curriculum-aligned tools that let you focus on your students rather than paperwork",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Grok Build",
        "url": "https://aixplore.in/tool_details?slug=grok-build",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/grok-build.png",
        "description": "An open-source command-line tool that gives developers direct access to Grok models from their terminal. You can code, converse, and automate AI tasks without leaving your usual development environment",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Floor Plan AI",
        "url": "https://aixplore.in/tool_details?slug=floor-plan-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/floor-plan-ai.png",
        "description": "A platform for generating 2D, 2.5D, and 3D floor plans online based on a prompt. You can easily experiment with room layouts and quickly export your floor plans for your architecture, renovation, or real estate projects",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Sydium",
        "url": "https://aixplore.in/tool_details?slug=sydium",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sydium.png",
        "description": "Set up your social media clone. The AI analyzes your past posts, learns your tone and habits, and then automatically writes, schedules, and publishes content on your behalf",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CraftMusic AI",
        "url": "https://aixplore.in/tool_details?slug=craftmusic-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/craftmusic-ai.png",
        "description": "Create songs, instrumentals, or lyrics based on an idea, style, or prompt. Choose the mood, instruments, and vocal direction, then download your best takes",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "TeraBox AI",
        "url": "https://aixplore.in/tool_details?slug=terabox-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/terabox-ai.png",
        "description": "An all-in-one AI workspace that lets you create presentations, text, images, videos, transcripts, and research, while keeping your files centralized and accessible",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "pdf.net",
        "url": "https://aixplore.in/tool_details?slug=pdf-net",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pdf-net.png",
        "description": "Create, summarize, and search your PDFs in seconds with AI. Generate professional documents (invoices, resumes, contracts) and get summaries or translations simply by entering a text prompt. The tool also supports annotation, page reorganization, and secure sharing",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Face AI",
        "url": "https://aixplore.in/tool_details?slug=face-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/face-ai.png",
        "description": "Have fun with ultra-realistic face swaps on photos, videos, or GIFs. You can swap, merge, or transform faces online quickly, with no watermarks or registration required",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gifify",
        "url": "https://aixplore.in/tool_details?slug=gifify",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gifify.png",
        "description": "Create animated GIFs from text or an image, then adjust the style, pace, and format to create a short, unique, and easy-to-share animation",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Adsmaker.ai",
        "url": "https://aixplore.in/tool_details?slug=adsmaker-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/adsmaker-ai.png",
        "description": "Create high-performing ads without a creative team. AI generates scripts, visuals, UGC videos, and variations for TikTok, Meta, Google, and Amazon. Works based on product descriptions (ready for your A/B tests)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "PodcastorAI",
        "url": "https://aixplore.in/tool_details?slug=podcastorai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/podcastorai.png",
        "description": "Turn an idea, an article, or an audio file into a full-fledged podcast. Create a structured script, choose the voices, add subtitles, and produce an audio or video podcast",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "MaxAEO",
        "url": "https://aixplore.in/tool_details?slug=maxaeo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/maxaeo.png",
        "description": "Monitor your visibility in the results of major AI assistants. The platform tracks your mentions, citations, rankings, and competitors on ChatGPT, Gemini, Perplexity, Claude, Copilot, Grok, and Google AI, then suggests concrete steps you can take to boost your visibility",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Meal Planner Pro",
        "url": "https://aixplore.in/tool_details?slug=meal-planner-pro",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/meal-planner-pro.png",
        "description": "Easily plan your meals and grocery shopping for the week. This handy tool offers recipes, personalized profiles for each family member, a calendar, and shopping lists. It helps you eat healthy every day",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Roger",
        "url": "https://aixplore.in/tool_details?slug=roger",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/roger.png",
        "description": "An AI agent connected to your Google Ads accounts to analyze your campaign performance, identify unnecessary spending, and suggest specific optimizations for you to review",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "OminiGate",
        "url": "https://aixplore.in/tool_details?slug=ominigate",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ominigate.png",
        "description": "Centralize all major AI models into a single OpenAI-compatible API. Use a single endpoint for text, images, and video, with automatic switching between providers, smart cost routing, and pay-as-you-go billing (no subscription required)",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Rootlenses",
        "url": "https://aixplore.in/tool_details?slug=rootlenses",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rootlenses.png",
        "description": "Analyze your data using natural language without writing a single SQL query. This platform connects your databases and generates real-time dashboards and reports. It also offers voice agents to easily automate your customer service calls",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Claude Fable 5",
        "url": "https://aixplore.in/tool_details?slug=claude-fable-5",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/claude-fable-5.png",
        "description": "Discover a next-generation AI model designed for advanced use while remaining highly secure. You\u2019ll enjoy top-tier performance for coding, analysis, and research, while safeguards block sensitive applications such as cybersecurity and biology",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VCFConverter",
        "url": "https://aixplore.in/tool_details?slug=vcfconverter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vcfconverter.png",
        "description": "Generate a vCard contact file from a list of phone numbers. Paste your numbers (with or without names), and the tool will create a .vcf file that you can then import into your phone all at once",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Fridgesnapai.recipes",
        "url": "https://aixplore.in/tool_details?slug=fridgesnapai-recipes",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/06/fridgesnap-ai-logo.webp",
        "description": "Take a photo of your fridge and get three recipe ideas based on the ingredients inside. AI detects the items, suggests dishes you can cook right away, and adds a generated image for each recipe",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Fetra AI",
        "url": "https://aixplore.in/tool_details?slug=fetra-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/fetra-ai.png",
        "description": "Manage your social media like a real marketing team. Take advantage of AI that spots trends, writes posts in your voice, schedules posts, and analyzes performance to help you maintain a consistent schedule (without having to juggle multiple tools)",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Capafy",
        "url": "https://aixplore.in/tool_details?slug=capafy",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/capafy.png",
        "description": "Monetize and download advanced skills for your AI agents. This marketplace lets you integrate \u201cSkills\u201d (such as an SEO audit, viral post writing, or a TikTok hook) directly into Claude Code, Codex, or OpenClaw via a simple URL",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Dreamina",
        "url": "https://aixplore.in/tool_details?slug=dreamina",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dreamina.png",
        "description": "Dreamina is an all-in-one AI image generator and AI video generator built for creators, marketers, designers, and everyday users",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "MAI-Thinking-1",
        "url": "https://aixplore.in/tool_details?slug=mai-thinking-1",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mai-thinking-1.png",
        "description": "Microsoft\u2019s new reasoning model, trained from scratch and optimized for code. It rivals the best models on SWE-Bench Pro and AIME 2025, while remaining medium-sized and computationally efficient",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Miraga AI",
        "url": "https://aixplore.in/tool_details?slug=miraga-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/miraga-ai.png",
        "description": "Turn your photos into realistic, cinematic videos in just a few seconds. Upload an image, choose a motion style, and get a smooth video that\u2019s ready to share or add to your projects",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Prophetic Dual",
        "url": "https://aixplore.in/tool_details?slug=prophetic-dual",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/prophetic-dual.png",
        "description": "A neurostimulation headband designed to promote lucid dreaming using low-intensity ultrasound. A futuristic technology at the intersection of sleep, neuroscience, and AI",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Dokie AI",
        "url": "https://aixplore.in/tool_details?slug=dokie-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dokie-ai.png",
        "description": "Create professional presentations in just a few minutes from plain text, notes, or a document. The AI generates the deck\u2019s structure, formats the slides, adds visuals, charts, and presentation notes, and then lets you export the file to PowerPoint, ready to present",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lalals",
        "url": "https://aixplore.in/tool_details?slug=lalals",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lalals.png",
        "description": "Compose original songs from a text, create covers by applying an AI voice to any recording, and clone your own voice. The platform also offers stem separation, noise removal, and real-time voice modification",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lip Sync",
        "url": "https://aixplore.in/tool_details?slug=lip-sync",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/06/lip-sync-ai-logo.webp",
        "description": "Make any face talk in just a few clicks. Upload a video or image, add audio or a script, and get realistic, perfectly synchronized lip movement. Perfect for your content, voiceovers, or creating talking avatars",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemini Spark",
        "url": "https://aixplore.in/tool_details?slug=gemini-spark",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemini-spark.png",
        "description": "A personal AI assistant available 24/7, even when your device is turned off. It connects to Gmail, Calendar, Drive, and your Google apps to proactively act on your behalf and manage your daily tasks independently",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Vmaker AI",
        "url": "https://aixplore.in/tool_details?slug=vmaker-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vmaker-ai.png",
        "description": "Create and edit professional-quality videos in minutes with AI. Using text, audio, or a screen recording, the tool generates videos featuring human avatars and animated captions. It can also automatically split your long videos into shorts",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lacuna",
        "url": "https://aixplore.in/tool_details?slug=lacuna",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lacuna.png",
        "description": "Create full songs from a simple text. Describe the mood or paste in your lyrics, and the AI will generate realistic music, arrangements, and vocals\u2014ready for your videos, podcasts, or streaming. Commercial rights are included for subscribers",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Vibrantsnap",
        "url": "https://aixplore.in/tool_details?slug=vibrantsnap",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vibrantsnap.png",
        "description": "Capture your screen and turn it into eye-catching visuals or videos that make people want to click. This AI automatically adds beautiful backgrounds, animations, and layouts, then generates short demo videos optimized to convert your visitors into customers",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Thumbs.ai",
        "url": "https://aixplore.in/tool_details?slug=thumbs-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/thumbs-ai.png",
        "description": "Create eye-catching YouTube thumbnails from text or an image. Compare multiple versions ready for A/B testing and boost your click-through rate without any design skills",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "machineko",
        "url": "https://aixplore.in/tool_details?slug=machineko",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/machineko.png",
        "description": "Chat with virtual cats inspired by real Japanese street cats. Each cat has its own personality and way of responding, and the interface lets you interact with them just like real companions. Perfect for cat lovers who are curious about \u201cwhat a cat might be thinking.\u201d",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "friend2chat",
        "url": "https://aixplore.in/tool_details?slug=friend2chat",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/friend2chat.png",
        "description": "Chat with virtual companions who truly understand you. Choose from a variety of characters, customize their personalities, and the AI will engage you in natural conversations that remember the context, feature voice interactions, and allow for image sharing",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Stable Audio 3.0",
        "url": "https://aixplore.in/tool_details?slug=stable-audio-3-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/stable-audio-3-0.png",
        "description": "Generate up to 6 minutes and 20 seconds of high-fidelity music or sounds from plain text. These open-source models also support editing, extension, and audio inpainting on consumer-grade hardware",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "UGCVideo.ai",
        "url": "https://aixplore.in/tool_details?slug=ugcvideo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ugcvideo-ai.png",
        "description": "Create realistic UGC videos from a simple product link or script. AI generates actors, voiceovers, and staging for your TikTok, Reels, or Shorts ads, without needing to hire real creators",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Futuro Corporation",
        "url": "https://aixplore.in/tool_details?slug=futuro-corporation",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/futuro-corporation.png",
        "description": "Automate your company\u2019s call handling with voice AI that answers calls 24/7, qualifies leads, and schedules appointments for you. Never miss a sales opportunity again",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Yard Design Studio",
        "url": "https://aixplore.in/tool_details?slug=ai-yard-design-studio",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-yard-design-studio.png",
        "description": "Visualize your future garden in just a few clicks. Upload a photo of your outdoor space, choose a style, and the AI will generate detailed landscape renderings complete with a shopping list and design ideas you can implement yourself",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Fruit",
        "url": "https://aixplore.in/tool_details?slug=ai-fruit",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-fruit.png",
        "description": "Create viral videos for TikTok and Instagram featuring talking animated fruits. Quickly generate funny stories using ASMR, mukbang, and drama modes",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VoiceAppear",
        "url": "https://aixplore.in/tool_details?slug=voiceappear",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/voiceappear.png",
        "description": "Dictate your text in any app on Windows or Mac using your voice. The tool converts speech to text in real time, automatically adds punctuation, and uses AI to correct your sentences. It lets you write up to three times faster",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Contriqo by Perfomir",
        "url": "https://aixplore.in/tool_details?slug=contriqo-by-perfomir",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/contriqo-by-perfomir.png",
        "description": "Analyze your construction contracts faster to identify hidden risks. This AI tool helps project teams identify risky clauses, manage commercial exposure, and better understand contractual obligations",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Pixo",
        "url": "https://aixplore.in/tool_details?slug=pixo",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/05/pixo-favicon-logo.webp",
        "description": "Create scripts, storyboards, and full-length videos with specialized AI agents that handle everything.  Perfect for YouTube, marketing, training, or music videos",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Cuey",
        "url": "https://aixplore.in/tool_details?slug=cuey",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/cuey.png",
        "description": "Compare multiple AI responses without leaving your favorite tool. This extension sends the same prompt to ChatGPT, Claude, Gemini, or Grok, and displays the responses side by side. It helps reduce hallucinations and makes your prompts and models easier to reuse",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Jovida",
        "url": "https://aixplore.in/tool_details?slug=jovida",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/jovida.png",
        "description": "Achieve your health and life goals with a proactive coach. This app helps you plan your habits, track your progress, and manage your daily routines. It sends you reminders at just the right time to help you stay on track without feeling pressured",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "vm0.ai",
        "url": "https://aixplore.in/tool_details?slug=vm0-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vm0-ai.png",
        "description": "Delegate your coordination tasks to an autonomous AI agent. \u201cZero\u201d connects to Slack, Gmail, Notion, or Linear to gather context and track the progress of your projects. It then drafts your meeting minutes and assigns tasks in a fully traceable manner",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "ERNIE 5.1",
        "url": "https://aixplore.in/tool_details?slug=ernie-5-1",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ernie-5-1.png",
        "description": "Baidu's flagship model is more cost-effective and powerful: it requires only one-third of the resources of its competitors and achieves a score of 99.6 on AIME26. It outperforms DeepSeek V4 Pro on several practical benchmarks and ranks first among Chinese models on LMArena Text",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Math Solver",
        "url": "https://aixplore.in/tool_details?slug=ai-math-solver",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/05/ai-math-solver-logo.webp",
        "description": "Solve your math problems simply by taking a photo: AI recognizes the problem, provides the answer, and breaks down each step of the calculation. An ideal tool to help you understand rather than just copy the answer, from middle school through college",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Designkit",
        "url": "https://aixplore.in/tool_details?slug=designkit",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/designkit.png",
        "description": "Easily create product images for your online store: AI analyzes your photos and generates professional product shots and logos optimized for Shopify, Etsy, eBay, and Amazon",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI People Search",
        "url": "https://aixplore.in/tool_details?slug=ai-people-search",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-people-search.png",
        "description": "Quickly find public information about anyone using a name, phone number, or email address. AI compiles social media profiles, contact information, and public records into a clear report, saving you the trouble of tedious manual searche",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Virtual Staging Art",
        "url": "https://aixplore.in/tool_details?slug=virtual-staging-art",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/virtual-staging-art.png",
        "description": "Enhance your real estate listings in 30 seconds: upload a photo of an empty room, choose an interior style, and the AI will generate a photorealistic image complete with furniture and decor. Perfect for attracting more buyers at a fraction of the cost of actual home staging",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Musiv AI",
        "url": "https://aixplore.in/tool_details?slug=musiv-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/musiv-ai.png",
        "description": "Create cinematic music videos in just a few minutes. Import your song, let the AI analyze the rhythm and emotions, and get a synchronized video with a custom storyboard and visual styles",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "TRELLIS.2",
        "url": "https://aixplore.in/tool_details?slug=trellis-2",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/trellis-2.png",
        "description": "Generate high-fidelity textured 3D objects from a single photo in under 10 seconds. This open-source model, featuring 4 billion parameters, produces PBR assets at resolutions up to 1536\u00b3, which can be instantly converted into GLB files ready for use in game engines, AR, and 3D printing",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Workflows Mistral",
        "url": "https://aixplore.in/tool_details?slug=workflows-mistral",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/workflows-mistral.png",
        "description": "Orchestrate complex AI pipelines in Python. This platform manages task sequencing, automatically handles errors, and ensures tasks are executed through to completion (with real-time monitoring)",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Miadance",
        "url": "https://aixplore.in/tool_details?slug=miadance",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/miadance.png",
        "description": "Create AI-generated videos and images in minutes using text, photos, or videos, with portrait animation, video restyling, editing (backgrounds, objects, faces), and high-definition export. You can use models such as Kling, Nano Banana, GPT-Image, or VEO (Google)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw AI Marvels",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-ai-marvels",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/hitpaw-marvel-logo.webp",
        "description": "Edit your photos and animate your videos right from your phone: make your pets dance, change their outfits, and apply anime, cartoon, or retro filters. Easily turn your portraits into stylized avatars",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "BeatMv",
        "url": "https://aixplore.in/tool_details?slug=beatmv",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/beatmv.png",
        "description": "Turn any song into a music video in minutes: AI analyzes BPM, breaks, and vocals, generates a scene-by-scene storyboard, and syncs lip-sync with the beats. You can export in vertical, square, or landscape formats, ready for social media",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Workspace Agents ChatGPT",
        "url": "https://aixplore.in/tool_details?slug=workspace-agents-chatgpt",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/workspace-agents-chatgpt.png",
        "description": "Automate your team workflows with shared agents that connect to your tools (Slack, CRM, Docs), run code, and track your processes. They can run in the background and handle recurring tasks such as lead qualification, feedback routing, or generating weekly reports",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lingbot-map",
        "url": "https://aixplore.in/tool_details?slug=lingbot-map",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/lingbot-map-logo.webp",
        "description": "Turn simple videos into real-time 3D maps: this cutting-edge open-source model reconstructs your environment frame by frame using a streaming-optimized geometric transformer. It delivers high accuracy while running at nearly 20 FPS over long sequences",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GPT\u20115.5",
        "url": "https://aixplore.in/tool_details?slug=gpt-5-5",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gpt---5-5.png",
        "description": "Tackle time-consuming and complex tasks by letting AI plan, use tools, check its work, and see tasks through to completion with minimal supervision. This model significantly improves coding, the use of virtual machines, online research, and knowledge work tasks",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "DeepSeek V4",
        "url": "https://aixplore.in/tool_details?slug=deepseek-v4",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/deepseek-v4.png",
        "description": "This Mixture-of-Experts model, with approximately 1 trillion parameters, features a 1M-token context, virtually infinite Engram memory, and multimodal capabilities for text, images, and video. It aims to achieve performance scores comparable to Claude Opus while remaining significantly more affordable (to be released under the Apache 2.0 license)",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "EaseMate AI",
        "url": "https://aixplore.in/tool_details?slug=easemate-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/easymate-ai-logo.webp",
        "description": "Combine studying, work, and creativity in a multi-model assistant (GPT, Gemini, Claude, DeepSeek, Nano Banana). This assistant can summarize PDFs and YouTube videos, solve math problems, and generate images, videos, and talking avatars in 17 languages",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw AI Audio Enhancer",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-ai-audio-enhancer",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/hitpaw-logo.png",
        "description": "Enhance your audio by removing background noise, hissing, and echoes, while boosting voice clarity. It only takes 3 steps: import your audio or video file, let the AI analyze the audio, then download a clean, professional result directly from your browser",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Mumble AI",
        "url": "https://aixplore.in/tool_details?slug=mumble-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mumble-ai.png",
        "description": "Record your meetings on Mac without any bots and get a live transcript with speaker identification, smart summaries, and generated actions (tasks, emails) using only your voice. Claimed to be 5 times faster than traditional note-taking, it works via the cloud or locally",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Claude Design",
        "url": "https://aixplore.in/tool_details?slug=claude-design",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/claude-design.png",
        "description": "Create prototypes, slides, web pages, marketing assets, and interactive experiences simply by chatting with Claude, who automatically applies your team\u2019s design system by reading your code and Figma files",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Heygen HyperFrames",
        "url": "https://aixplore.in/tool_details?slug=heygen-hyperframes",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/heygen-hyperframes.png",
        "description": "Generate videos from simple HTML pages using an open-source framework designed for AI agents. Rendering is deterministic and command-line controllable, with a catalog of ready-to-use blocks for graphics, overlays, and layouts",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Google Flow Music",
        "url": "https://aixplore.in/tool_details?slug=google-flow-music",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/google-flow-music.png",
        "description": "Compose and edit your music in real time using AI, controlling the genre, instruments, mood, tempo, and intensity, all in 48 kHz audio",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Hermes Agent",
        "url": "https://aixplore.in/tool_details?slug=hermes-agent",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hermes-agent.png",
        "description": "Install an open-source agent on your own machine that remembers everything, improves over time, and orchestrates your complex tasks (web, code, files, APIs) using a variety of tools and templates. A single command is all it takes to deploy it on Linux, macOS, or WSL2",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Palabra.ai",
        "url": "https://aixplore.in/tool_details?slug=palabra-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/palabra-ai.png",
        "description": "Translate your spoken conversations into over 60 languages with less than a second of latency, while preserving your voice, style, and tone as much as possible. Ideal for conferences, live streaming, and calls, with APIs, SDKs, and enterprise-grade security",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Claude Opus 4.7",
        "url": "https://aixplore.in/tool_details?slug=claude-opus-4-7",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/claude-opus-4-7.png",
        "description": "Anthropic's latest high-end model, optimized for agentic code, long-running tasks, and critical business scenarios. It features self-checking of responses and a context window of one million tokens. It is also capable of automatically adjusting the depth of its reasoning based on the difficulty of the problem",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Qwen3.6\u201135B",
        "url": "https://aixplore.in/tool_details?slug=qwen3-6-35b",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/qwen3-6---35b.png",
        "description": "Run a 35-billion-parameter MoE model with only 3 billion parameters actually activated, while achieving coding, vision, and reasoning performance on par with much larger models. Optimized for agentic coding, multimodal perception, and very long contexts (up to over a million tokens)",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Skygen",
        "url": "https://aixplore.in/tool_details?slug=skygen",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/skygen.png",
        "description": "Let an AI agent manage your tasks across all your devices, from sorting emails and creating presentations to planning, drafting, and tracking projects. It directly controls your computer and apps with a comprehensive activity log, all while ensuring privacy through local processing",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GPT\u2011Rosalind",
        "url": "https://aixplore.in/tool_details?slug=gpt-rosalind",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gpt---rosalind.png",
        "description": "Accelerate your research in biology, genomics, and drug discovery with a specialized model that combines advanced scientific reasoning, access to biomedical databases, and in-house agents. Ideal for analyzing, prioritizing, and designing end-to-end experiments",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemini 3.1 Flash TTS",
        "url": "https://aixplore.in/tool_details?slug=gemini-3-1-flash-tts",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemini-3-1-flash-tts.png",
        "description": "A natural and expressive voice generator that supports over 70 languages via text-to-speech (TTS). Features fine-grained control over style, rhythm, and emotions using natural-language audio tags. The model is also capable of handling multiple speakers simultaneously",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lyra 2.0 Nvidia",
        "url": "https://aixplore.in/tool_details?slug=lyra-2-0-nvidia",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/nvidia-logo-favicon.webp",
        "description": "Turn a single image or video into a persistent 3D world that can be explored endlessly, without the AI \u201cforgetting\u201d areas it has already visited. The generated scenes can be easily exported as Gaussian Splats or meshes directly into NVIDIA Isaac Sim for robotic simulation",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw AI Photo Enhancer",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-ai-photo-enhancer",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/hitpaw-AI-photo.webp",
        "description": "Make your photos sharp, detailed, and high-resolution right in your browser: sharpening, noise reduction, colorization, and restoration of old images up to 8\u00d7, free for small upscales",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Muse Spark",
        "url": "https://aixplore.in/tool_details?slug=muse-spark",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/muse-spark.png",
        "description": "The first model developed by Meta Superintelligence Labs, built from scratch in nine months and natively multimodal (text, image, voice). Its \u201cContemplating\u201d mode coordinates multiple sub-agents in parallel and is already powering Meta AI on Facebook, Instagram, and WhatsApp",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "BlipCut Video Translator",
        "url": "https://aixplore.in/tool_details?slug=blipcut-video-translator",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/blipcut-video-translator.png",
        "description": "Save a significant amount of time on video translation with a comprehensive AI solution: automatic transcription, translation, and dubbing in over 140 languages",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Chattee",
        "url": "https://aixplore.in/tool_details?slug=chattee",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/chattee.png",
        "description": "Describe your application, and the platform generates a full-stack web app ready for deployment. It includes role management, workflows, API integrations, and SSL hosting. You receive the complete source code, giving you full ownership of it",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Anymelo",
        "url": "https://aixplore.in/tool_details?slug=anymelo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/anymelo.png",
        "description": "Create full songs, instrumentals, and vocal covers from a simple text or set of lyrics. The tool generates vocals and arrangements, extends your tracks, and isolates stems for your remixes, with no musical knowledge required",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "PresentButler",
        "url": "https://aixplore.in/tool_details?slug=presentbutler",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/presentbutler.png",
        "description": "Perfect for those who are short on inspiration, this assistant offers gift ideas based on the recipient, the occasion, and your budget. The service refines its suggestions by chatting with you and directs you to products to purchase",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Whacka",
        "url": "https://aixplore.in/tool_details?slug=whacka",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/whacka.png",
        "description": "Turn ideas into live apps directly from your phone, while AI handles the design, build, and deployment \u2014 no code or setup required",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Adobe Acrobat Student Spaces",
        "url": "https://aixplore.in/tool_details?slug=adobe-acrobat-student-spaces",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/acrobat-pro-icon.webp",
        "description": "Turn your lectures, PDFs, and notes into flashcards, quizzes, mind maps, videos, and podcasts with the help of a built-in AI tutor. The tool automatically cites your sources to prevent errors and centralizes all your group work in one place",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Google AI Edge Eloquent",
        "url": "https://aixplore.in/tool_details?slug=google-ai-edge-eloquent",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/google-ai-edge-eloquent.png",
        "description": "Dictate text into your phone, and the AI will transcribe it, remove hesitations, and reformat the result as bullet points, in a formal tone, or as a short summary. The app works entirely offline, with no subscription or data usage required",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GPT for Work",
        "url": "https://aixplore.in/tool_details?slug=gpt-for-work",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gpt-for-work.png",
        "description": "Automate tasks in Google Sheets, Excel, Docs, and Word directly from your spreadsheet using natural language: data cleaning, formula creation, pivot tables, charts, and bulk processing of up to 500,000 rows per run. Compatible with GPT, Claude, Gemini, DeepSeek, and Mistral",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "HitPaw Univd",
        "url": "https://aixplore.in/tool_details?slug=hitpaw-univd",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/hitpaw-univd-logo.webp",
        "description": "Convert, compress, and enhance your videos in over 1,000 formats up to 170 times faster than traditional tools, without any loss of quality. Built-in AI models also let you upscale videos to 4K/8K, colorize black-and-white videos, and stabilize shaky footage",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Linked Helper",
        "url": "https://aixplore.in/tool_details?slug=linked-helper",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/linked-helper.png",
        "description": "Automate your LinkedIn outreach with personalized message sequences, profile visits, and bulk invitations via a discreet desktop app. The tool detects responses and stops the automation as soon as a conversation turns into a human interaction",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Pine AI",
        "url": "https://aixplore.in/tool_details?slug=pine-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pine-ai.png",
        "description": "An AI agent that makes calls and sends emails on your behalf to negotiate your bills, cancel subscriptions, request refunds, and handle customer disputes. You describe the problem, and it takes care of everything from start to finish",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemma 4",
        "url": "https://aixplore.in/tool_details?slug=gemma-4",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemma-4.png",
        "description": "Take advantage of enhanced audio and visual understanding to create comprehensive multimodal applications, ranging from image analysis to audio interpretation. The open-source E2B and E4B models offer optimal memory capacity and computational efficiency. Perfect for inference on devices with limited resources",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Qwen3.6-Plus",
        "url": "https://aixplore.in/tool_details?slug=qwen3-6-plus",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/qwen3-6-plus.png",
        "description": "Alibaba's new leading model codes, tests, and debugs entire projects autonomously using a 1-million-token prompt. It generates web interfaces from screenshots, understands images and documents, and integrates directly with Claude Code via the Anthropic API",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Stackmint",
        "url": "https://aixplore.in/tool_details?slug=stackmint",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/stackmint.png",
        "description": "Verify permissions, budget, and execution paths before any production deployment. Each AI workflow is governed by safeguards and contractual KPIs. A powerful platform ideal for businesses",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Wan2.7 Image",
        "url": "https://aixplore.in/tool_details?slug=wan2-7-image",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wan2-7-image.png",
        "description": "Generate images with precise color control using hex codes and up to 9 reference photos. This Alibaba template ensures consistent faces and legible text directly in your images",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Qwen3.5 Omni",
        "url": "https://aixplore.in/tool_details?slug=qwen3-5-omni",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/qwen3-5-omni.png",
        "description": "This multimodal model understands and generates text, images, audio, and video all within a single interface. It recognizes speech in 113 languages and responds verbally in 36 languages",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "PixPark AI",
        "url": "https://aixplore.in/tool_details?slug=pixpark-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pixpark-ai.png",
        "description": "An image generator capable of producing all types of content, from video game assets to marketing and social media images. Its real advantage is the choice between several engines, including Seedream and Nano Banana",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "WeryAI",
        "url": "https://aixplore.in/tool_details?slug=weryai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/weryai.png",
        "description": "Access the best video and image models (Kling, Veo, Sora 2, FLUX) all from a single platform. You can also create consistent characters and swap faces between videos without switching tools",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "WAbot",
        "url": "https://aixplore.in/tool_details?slug=wabot",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/wabot-logo.png",
        "description": "A sales assistant for WhatsApp that detects purchase intent, suggests responses, and translates messages in real time. It also summarizes each conversation and pushes the information to your CRM",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Genfaceless",
        "url": "https://aixplore.in/tool_details?slug=genfaceless",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/genfaceless.png",
        "description": "Automatically generate faceless videos for social media (YouTube, TikTok, or Reels). From script to final edit, AI handles the entire creation process for you",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Saveto AI",
        "url": "https://aixplore.in/tool_details?slug=saveto-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/saveto-ai.png",
        "description": "Save time during your meetings, podcasts, and interviews with fast automatic transcription. The built-in multilingual translation feature makes international collaboration easier. Compatible with over 200 languages, multiple speakers, and video uploads",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Crun AI",
        "url": "https://aixplore.in/tool_details?slug=crun-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/crun-ai.png",
        "description": "A single API to access over 100 image, video, and audio models without having to set up multiple integrations. Convenient for testing Veo, Kling, Flux, Suno, and other services through the same gateway",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VEME",
        "url": "https://aixplore.in/tool_details?slug=veme",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/veme.png",
        "description": "A video generator that combines simplicity and power: enter a prompt or upload an image, then get a high-quality video. Quickly access AI models such as Veo, Kling, and Seedance",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Video Cutter",
        "url": "https://aixplore.in/tool_details?slug=video-cutter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/video-cutter.png",
        "description": "An online editor that lets you trim a video in seconds, with no account required and no watermark. Supports MP4, MOV, AVI, MKV, and WebM, with fast export and preserved quality",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "MiniMax M2.7",
        "url": "https://aixplore.in/tool_details?slug=minimax-m2-7",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/minimax-m2-7.png",
        "description": "This model improves upon the previous M2.5 version in terms of agentic coding, office productivity, and following complex instructions. It self-improves by building its own skills to learn continuously, achieving the highest open-source ELO score on GDPval-AA",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Questie AI",
        "url": "https://aixplore.in/tool_details?slug=questie-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/questie-ai.png",
        "description": "This gaming assistant monitors your screen in real time and responds aloud while you play. You can create a personalized companion that coaches you, comments on your stream, or simply keeps you company, without ever having to leave your game to type a message",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Team9",
        "url": "https://aixplore.in/tool_details?slug=team9",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/team9.png",
        "description": "An AI workspace built on OpenClaw and Moltbook. It lets you hire AI Staff inside the product and collaborate with them like teammates. Instant deployment of OpenClaw, with no installation or configuration required",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Rehumanize.io",
        "url": "https://aixplore.in/tool_details?slug=rehumanize-io",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rehumanize-io.png",
        "description": "Paste your AI-generated text (ChatGPT, Claude) and the tool will instantly rewrite it to give it a more natural style, without changing the meaning. It bypasses the main AI detectors and supports documents of up to 50,000 words at a time",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Sugarbug",
        "url": "https://aixplore.in/tool_details?slug=sugarbug",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sugarbug.png",
        "description": "Connect Linear, GitHub, Figma, Slack, Notion, and your calendar to create a dynamic knowledge graph of your team. The AI categorizes each signal, prepares your meeting briefs, and generates status updates before you even ask for them",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Expert Pitch",
        "url": "https://aixplore.in/tool_details?slug=expert-pitch",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/03/favicon.png",
        "description": "This AI-powered PR assistant analyzes journalists' requests every day and automatically sends personalized pitches on your behalf. Ideal for getting high-quality backlinks and improving your SEO",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Ask Maps",
        "url": "https://aixplore.in/tool_details?slug=ask-maps",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ask-maps.png",
        "description": "Ask questions in natural language directly in Google Maps to plan a route or find a place that suits your needs. Navigation now displays a realistic 3D view featuring buildings, roads, traffic lights, and crosswalks",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Hitem3D",
        "url": "https://aixplore.in/tool_details?slug=hitem3d",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hitem3d.png",
        "description": "A 3D generator that converts an image into a detailed model with custom textures and production-ready geometry. Export to FBX, GLB, OBJ, or STL for 3D printing, gaming, AR, or VFX",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Eyematch.ai",
        "url": "https://aixplore.in/tool_details?slug=eyematch-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/eyematch-ai.png",
        "description": "Upload a photo of a face, and the AI will scan the internet to find where that person appears online. A useful facial search engine for verifying identities, detecting catfish, or finding out if your images are being used without permission",
        "pricing": "Paid",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AIReel",
        "url": "https://aixplore.in/tool_details?slug=aireel",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/aireel.png",
        "description": "A video generator combining several models, including Veo 3.1, Seedance, Sora, and Kling, to create more varied scenes from text or images. Social media-friendly formats, cinematic rendering, and a simple workflow let you publish faster",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Picsart Enterprise",
        "url": "https://aixplore.in/tool_details?slug=picsart-enterprise",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/picsart-enterprise.png",
        "description": "Integrate Picsart's creative APIs directly into your applications to remove backgrounds, upscaling, enhance, or generate AI-powered visuals at scale. The tool connects to Google Drive, OpenAI, and Gemini to automate your creative workflows",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "EzMaker AI",
        "url": "https://aixplore.in/tool_details?slug=ezmaker-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ezmaker-ai.png",
        "description": "Quickly clean up and enhance your images. This AI photo editor removes backgrounds, retouches images, improves image quality, and even handles batch processing to speed up the preparation of your e-commerce or social media visuals",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Buda AI",
        "url": "https://aixplore.in/tool_details?slug=buda-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/buda-ai.png",
        "description": "Deploy real, persistent AI agents that collaborate on your projects. The platform orchestrates specialized agents capable of handling research, content, sales, support, code, data, and automations within a collaborative cloud environment.",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Free Music Creator AI",
        "url": "https://aixplore.in/tool_details?slug=free-music-creator-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/free-music-creator-ai.png",
        "description": "Compose music for free using simple prompts or lyrics. The platform generates songs, instrumentals, lyrics, track separations, and mastering for your video or podcast projects",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Luminar Neo",
        "url": "https://aixplore.in/tool_details?slug=luminar-neo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/luminar-neo.png",
        "description": "Edit your photos like a pro with an AI-powered editor. Remove objects, replace skies, enhance skin tones, add bokeh, enlarge or restore images: you\u2019ll get studio-quality results without a complicated learning curve. Available in English and German",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "GLM-5.2",
        "url": "https://aixplore.in/tool_details?slug=glm-5-2",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/glm-5-2.png",
        "description": "An open-source model designed for code and long-running tasks, with a context window of up to 1 million tokens. This Mixed Expert (MoE) LLM handles complex projects, analyzes entire repositories, and performs multi-step reasoning. It is available as open source under the MIT license",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Gemini 3.5 Live Translate",
        "url": "https://aixplore.in/tool_details?slug=gemini-3-5-live-translate",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemini-3-5-live-translate.png",
        "description": "Translate live conversations with Google's AI, which recognizes more than 70 languages, provides smooth voice output, and facilitates multilingual communication in Google Translate or Meet",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Audio Transcriber AI",
        "url": "https://aixplore.in/tool_details?slug=audio-transcriber-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/audio-transcriber-ai.png",
        "description": "This tool automatically converts your audio files into readable text. You upload a recording (meeting, podcast, voice memo) and get a clear transcript that you can review, search, or reuse",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CharaVerse",
        "url": "https://aixplore.in/tool_details?slug=charaverse",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/charaverse.png",
        "description": "Talk to characters from anime and webtoons in role-playing scenarios written as interactive fiction. You choose a character type (yandere, demon, academic rival, etc.) and let the story unfold based on your messages",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "LeadAI",
        "url": "https://aixplore.in/tool_details?slug=leadai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/leadai.png",
        "description": "Easily verify your phone numbers before launching your campaigns. This free tool lets you check the carrier, approximate location, and validity of each number to clean up your lists and avoid sending messages to invalid numbers",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Shoomble",
        "url": "https://aixplore.in/tool_details?slug=shoomble",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/shoomble.png",
        "description": "Chat with a selection of the best AI characters available online. Quickly develop role-playing scenarios or test different types of AI-assisted social interactions. This platform features AI girlfriends, AI boyfriends, and anime-inspired characters",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Wondershare Recoverit",
        "url": "https://aixplore.in/tool_details?slug=wondershare-recoverit",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/06/wondershare-recoverit-logo.webp",
        "description": "Easily recover your deleted or corrupted files using AI. The software scans your hard drives, SD cards, or cameras and restores photos, videos, and documents with a very high success rate, even after formatting",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Botreon",
        "url": "https://aixplore.in/tool_details?slug=botreon",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/botreon.png",
        "description": "Chat with different bots in your messaging apps, create your own chatbots, and build an audience around your interactive experiences",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "TubeRepeat",
        "url": "https://aixplore.in/tool_details?slug=tuberepeat",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/tuberepeat.png",
        "description": "Repeat a specific section of a YouTube video over and over again to practice. Paste the URL, set the start and end points down to the second, adjust the speed, and count your repetitions",
        "pricing": "Free",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VidTranslate",
        "url": "https://aixplore.in/tool_details?slug=vidtranslate",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/vidtranslate.png",
        "description": "Translate, subtitle, and dub your videos in over 100 languages directly online. The tool extracts subtitles, translates them, generates dubbed audio tracks, and lets you export them in SRT, TXT, ASS, or MP4 formats",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Facefame",
        "url": "https://aixplore.in/tool_details?slug=facefame",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/facefame.png",
        "description": "A platform for easily creating AI avatars and portraits from a selfie. Generate ID photos, professional headshots, anime avatars, or animated profile videos in a variety of styles",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "VideoWeb AI",
        "url": "https://aixplore.in/tool_details?slug=videoweb-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/videoweb-ai.png",
        "description": "Easily generate videos, images, and music using an all-in-one AI suite. Start with text or an illustration, and the tool uses models such as Seedance, VEO, Kling, Gro, and Imagine to produce HD content",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CometAPI",
        "url": "https://aixplore.in/tool_details?slug=cometapi",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/06/cometapi-logo.webp",
        "description": "Centralize access to more than 500 AI models (LLMs, image, video, audio) through a single API. Connect GPT Image 2, Claude Opus 4.8, Gemini 3.1 Pro, and others via a single endpoint. With latency optimized for production use",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Loopa",
        "url": "https://aixplore.in/tool_details?slug=loopa",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/loopa.png",
        "description": "Entrust your digital tasks to an AI agent that plans and executes them for you. It can prepare presentations, research, or websites in multiple steps to help you get more done with less effort",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Kane CLI By TestMu AI",
        "url": "https://aixplore.in/tool_details?slug=kane-cli-by-testmu-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/08/kaneAI-favicon.png",
        "description": "Terminal-native AI testing tool. Describe a browser flow in plain English; Kane CLI runs it in real Chrome and returns pass/fail with a shareable evidence link",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Gantt chart maker",
        "url": "https://aixplore.in/tool_details?slug=ai-gantt-chart-maker",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-gantt-chart-maker.png",
        "description": "Generate a complete Gantt chart from a simple project description. You define the objectives, deadlines, and teams, and you\u2019ll quickly receive a structured schedule that you can share with your team",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "CreateMemorial",
        "url": "https://aixplore.in/tool_details?slug=creatememorial",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/creatememorial.png",
        "description": "Create an online memorial to honor a loved one using photos, text, and tributes. The platform also generates a 1080p commemorative video from your albums, which you can share with your friends and family",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "AI Resumma",
        "url": "https://aixplore.in/tool_details?slug=ai-resumma",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-resumma.png",
        "description": "Upload text, PDF files, presentations, or links: AI will generate a clear summary, extract text from images, and can also translate or rewrite your documents into more than 20 languages",
        "pricing": "Free-Trial",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Lium.ai",
        "url": "https://aixplore.in/tool_details?slug=lium-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lium-ai.png",
        "description": "Analyze complex datasets (geospatial, energy, infrastructure, telemetry, etc.) using AI designed for scientists and analysts. Connect your data sources, ask questions in natural language, and the \u201cagentic harness\u201d restructures the data to provide reliable answers (based on raw and heterogeneous data)",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      },
      {
        "name": "Pixmax.ai",
        "url": "https://aixplore.in/tool_details?slug=pixmax-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pixmax-ai.png",
        "description": "Create high-quality AI videos from text, images, or clips. This site features a visual canvas for scripting, editing, and customizing your content, with reliable workflows. Ideal for advertising, e-commerce, and social media content",
        "pricing": "Freemium",
        "categories": [
          "Latest AI"
        ]
      }
    ]
  },
  {
    "category": "Top Trending",
    "tools": [
      {
        "name": "ChatGPT",
        "url": "https://aixplore.in/tool_details?slug=chatgpt",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/14.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Claude Code",
        "url": "https://aixplore.in/tool_details?slug=claude-code",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/107.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://aixplore.in/tool_details?slug=openclaw",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/115.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Free",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Gemini",
        "url": "https://aixplore.in/tool_details?slug=gemini",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/18.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Higgsfield AI",
        "url": "https://aixplore.in/tool_details?slug=higgsfield",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/34.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Google Antigravity",
        "url": "https://aixplore.in/tool_details?slug=google-antigravity",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/101.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Free",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "OpenAI Codex",
        "url": "https://aixplore.in/tool_details?slug=openai-codex",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/106.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Claude",
        "url": "https://aixplore.in/tool_details?slug=claude",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/16.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "ElevenLabs",
        "url": "https://aixplore.in/tool_details?slug=elevenlabs",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/105.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "NotebookLM",
        "url": "https://aixplore.in/tool_details?slug=notebooklm",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/113.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Perplexity.ai",
        "url": "https://aixplore.in/tool_details?slug=perplexity",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/19.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Comet",
        "url": "https://aixplore.in/tool_details?slug=comet-browser",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/40.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "n8n.io",
        "url": "https://aixplore.in/tool_details?slug=n8n",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/20.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Canva",
        "url": "https://aixplore.in/tool_details?slug=canva",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/78.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Open Router",
        "url": "https://aixplore.in/tool_details?slug=openrouter",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/86.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Hugging Face",
        "url": "https://aixplore.in/tool_details?slug=hugging-face",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/89.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Stich",
        "url": "https://aixplore.in/tool_details?slug=google-stitch",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/94.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Free",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Figma",
        "url": "https://aixplore.in/tool_details?slug=figma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/97.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "Cursor",
        "url": "https://aixplore.in/tool_details?slug=cursor",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/1.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      },
      {
        "name": "V0",
        "url": "https://aixplore.in/tool_details?slug=v0",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/3.png",
        "description": "Leading platform for Top Trending.",
        "pricing": "Premium",
        "categories": [
          "Top Trending"
        ]
      }
    ]
  },
  {
    "category": "Popular Tools",
    "tools": [
      {
        "name": "Microsoft 365",
        "url": "https://aixplore.in/tool_details?slug=microsoft",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/79.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "ChatGPT",
        "url": "https://aixplore.in/tool_details?slug=chatgpt",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/14.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Figma",
        "url": "https://aixplore.in/tool_details?slug=figma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/97.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Notion",
        "url": "https://aixplore.in/tool_details?slug=notion",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/83.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Canva",
        "url": "https://aixplore.in/tool_details?slug=canva",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/78.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Coursera",
        "url": "https://aixplore.in/tool_details?slug=coursera",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/74.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Grammarly",
        "url": "https://aixplore.in/tool_details?slug=grammarly",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/43.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Adobe Creative Cloud",
        "url": "https://aixplore.in/tool_details?slug=adobe-creative-cloud",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/33.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Meta AI",
        "url": "https://aixplore.in/tool_details?slug=meta-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/118.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "ElevenLabs",
        "url": "https://aixplore.in/tool_details?slug=elevenlabs",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/105.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Firebase",
        "url": "https://aixplore.in/tool_details?slug=firebase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/96.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "JetBrains",
        "url": "https://aixplore.in/tool_details?slug=jetbrains",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/73.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Miro",
        "url": "https://aixplore.in/tool_details?slug=miro",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/52.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Postman",
        "url": "https://aixplore.in/tool_details?slug=postman",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/50.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Zapier",
        "url": "https://aixplore.in/tool_details?slug=zapier",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/22.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Gemini",
        "url": "https://aixplore.in/tool_details?slug=gemini",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/18.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Claude Code",
        "url": "https://aixplore.in/tool_details?slug=claude-code",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/107.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Behance",
        "url": "https://aixplore.in/tool_details?slug=behance",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/100.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Duolingo",
        "url": "https://aixplore.in/tool_details?slug=duolingo",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/82.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      },
      {
        "name": "Freepik",
        "url": "https://aixplore.in/tool_details?slug=freepik",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/103.png",
        "description": "Leading platform for Popular Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Popular Tools"
        ]
      }
    ]
  },
  {
    "category": "Developer Tools",
    "tools": [
      {
        "name": "Postman",
        "url": "https://aixplore.in/tool_details?slug=postman",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/50.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "JetBrains",
        "url": "https://aixplore.in/tool_details?slug=jetbrains",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/73.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Firebase",
        "url": "https://aixplore.in/tool_details?slug=firebase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/96.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Claude Code",
        "url": "https://aixplore.in/tool_details?slug=claude-code",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/107.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Replit",
        "url": "https://aixplore.in/tool_details?slug=replit",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/12.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Hugging Face",
        "url": "https://aixplore.in/tool_details?slug=hugging-face",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/89.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "OpenAI Codex",
        "url": "https://aixplore.in/tool_details?slug=openai-codex",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/106.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Ollama",
        "url": "https://aixplore.in/tool_details?slug=ollama",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/116.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Supabase",
        "url": "https://aixplore.in/tool_details?slug=supabase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/93.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Groq",
        "url": "https://aixplore.in/tool_details?slug=groq",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/87.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://aixplore.in/tool_details?slug=openclaw",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/115.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Manus",
        "url": "https://aixplore.in/tool_details?slug=manus",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/117.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Warp.dev",
        "url": "https://aixplore.in/tool_details?slug=warp",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/4.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Bolt.new",
        "url": "https://aixplore.in/tool_details?slug=bolt-new",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/11.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Requestly",
        "url": "https://aixplore.in/tool_details?slug=requestly",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/57.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Apify",
        "url": "https://aixplore.in/tool_details?slug=apify",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/90.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "RapidAPI",
        "url": "https://aixplore.in/tool_details?slug=rapidapi",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/104.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Cursor",
        "url": "https://aixplore.in/tool_details?slug=cursor",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/1.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Windsurf",
        "url": "https://aixplore.in/tool_details?slug=windsurf",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/5.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      },
      {
        "name": "Open Router",
        "url": "https://aixplore.in/tool_details?slug=openrouter",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/86.png",
        "description": "Leading platform for Developer Tools.",
        "pricing": "Not Specified",
        "categories": [
          "Developer Tools"
        ]
      }
    ]
  },
  {
    "category": "Assistance Code",
    "tools": [
      {
        "name": "Claude Code",
        "url": "https://aixplore.in/tool_details?slug=claude-code",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/107.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Replit",
        "url": "https://aixplore.in/tool_details?slug=replit",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/12.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Devin AI",
        "url": "https://aixplore.in/tool_details?slug=devin",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/26.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "OpenAI Codex",
        "url": "https://aixplore.in/tool_details?slug=openai-codex",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/106.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://aixplore.in/tool_details?slug=openclaw",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/115.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Warp.dev",
        "url": "https://aixplore.in/tool_details?slug=warp",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/4.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Bolt.new",
        "url": "https://aixplore.in/tool_details?slug=bolt-new",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/11.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Cursor",
        "url": "https://aixplore.in/tool_details?slug=cursor",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/1.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "V0",
        "url": "https://aixplore.in/tool_details?slug=v0",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/3.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Windsurf",
        "url": "https://aixplore.in/tool_details?slug=windsurf",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/5.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Lovable.dev",
        "url": "https://aixplore.in/tool_details?slug=lovable",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/8.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Google Antigravity",
        "url": "https://aixplore.in/tool_details?slug=google-antigravity",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/101.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "21st.dev",
        "url": "https://aixplore.in/tool_details?slug=21st-dev",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/114.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Tempo Labs",
        "url": "https://aixplore.in/tool_details?slug=tempo",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/6.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Blackbox AI",
        "url": "https://aixplore.in/tool_details?slug=blackbox-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/17.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Dualite.dev",
        "url": "https://aixplore.in/tool_details?slug=dualite",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/7.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Cosine",
        "url": "https://aixplore.in/tool_details?slug=cosine",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/55.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "Trae",
        "url": "https://aixplore.in/tool_details?slug=trae",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/95.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "riff",
        "url": "https://aixplore.in/tool_details?slug=riff",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/2.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      },
      {
        "name": "TestSprite",
        "url": "https://aixplore.in/tool_details?slug=testsprite",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/109.png",
        "description": "Leading platform for Assistance Code.",
        "pricing": "Not Specified",
        "categories": [
          "Assistance Code"
        ]
      }
    ]
  },
  {
    "category": "Websites and Design",
    "tools": [
      {
        "name": "Adobe Creative Cloud",
        "url": "https://aixplore.in/tool_details?slug=adobe-creative-cloud",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/33.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Canva",
        "url": "https://aixplore.in/tool_details?slug=canva",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/78.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Figma",
        "url": "https://aixplore.in/tool_details?slug=figma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/97.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Webflow",
        "url": "https://aixplore.in/tool_details?slug=webflow",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/54.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Freepik",
        "url": "https://aixplore.in/tool_details?slug=freepik",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/103.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Framer",
        "url": "https://aixplore.in/tool_details?slug=framer",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/10.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Gamma",
        "url": "https://aixplore.in/tool_details?slug=gamma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/47.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Hostinger AI Website Builder",
        "url": "https://aixplore.in/tool_details?slug=hostinger-ai-website-builder",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/108.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Manus",
        "url": "https://aixplore.in/tool_details?slug=manus",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/117.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Tilda",
        "url": "https://aixplore.in/tool_details?slug=tilda",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/30.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Name.com",
        "url": "https://aixplore.in/tool_details?slug=name-com",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/84.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "21st.dev",
        "url": "https://aixplore.in/tool_details?slug=21st-dev",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/114.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Neo.space",
        "url": "https://aixplore.in/tool_details?slug=neo",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/32.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "UX Pilot",
        "url": "https://aixplore.in/tool_details?slug=ux-pilot",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/99.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Stich",
        "url": "https://aixplore.in/tool_details?slug=google-stitch",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/94.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Base44",
        "url": "https://aixplore.in/tool_details?slug=base44",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/111.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      },
      {
        "name": "Easysite",
        "url": "https://aixplore.in/tool_details?slug=easysite",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/9.png",
        "description": "Leading platform for Websites and Design.",
        "pricing": "Not Specified",
        "categories": [
          "Websites and Design"
        ]
      }
    ]
  },
  {
    "category": "AI Chat and Assistant",
    "tools": [
      {
        "name": "ChatGPT",
        "url": "https://aixplore.in/tool_details?slug=chatgpt",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/14.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Gemini",
        "url": "https://aixplore.in/tool_details?slug=gemini",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/18.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Meta AI",
        "url": "https://aixplore.in/tool_details?slug=meta-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/118.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Claude Code",
        "url": "https://aixplore.in/tool_details?slug=claude-code",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/107.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Claude",
        "url": "https://aixplore.in/tool_details?slug=claude",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/16.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Perplexity.ai",
        "url": "https://aixplore.in/tool_details?slug=perplexity",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/19.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "NotebookLM",
        "url": "https://aixplore.in/tool_details?slug=notebooklm",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/113.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Ollama",
        "url": "https://aixplore.in/tool_details?slug=ollama",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/116.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Hostinger AI Website Builder",
        "url": "https://aixplore.in/tool_details?slug=hostinger-ai-website-builder",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/108.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "You.com",
        "url": "https://aixplore.in/tool_details?slug=you-com",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/49.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "DeepSeek",
        "url": "https://aixplore.in/tool_details?slug=deepseek",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/15.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Comet",
        "url": "https://aixplore.in/tool_details?slug=comet-browser",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/40.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "ChatPRD",
        "url": "https://aixplore.in/tool_details?slug=chatprd",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/41.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "BoodleBox",
        "url": "https://aixplore.in/tool_details?slug=boodlebox",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/56.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "Trae",
        "url": "https://aixplore.in/tool_details?slug=trae",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/95.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      },
      {
        "name": "UX Pilot",
        "url": "https://aixplore.in/tool_details?slug=ux-pilot",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/99.png",
        "description": "Leading platform for AI Chat and Assistant.",
        "pricing": "Not Specified",
        "categories": [
          "AI Chat and Assistant"
        ]
      }
    ]
  },
  {
    "category": "Productivity",
    "tools": [
      {
        "name": "Microsoft 365",
        "url": "https://aixplore.in/tool_details?slug=microsoft",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/79.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Notion",
        "url": "https://aixplore.in/tool_details?slug=notion",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/83.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Figma",
        "url": "https://aixplore.in/tool_details?slug=figma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/97.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Miro",
        "url": "https://aixplore.in/tool_details?slug=miro",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/52.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "ClickUp",
        "url": "https://aixplore.in/tool_details?slug=clickup",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/25.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Raycast",
        "url": "https://aixplore.in/tool_details?slug=raycast",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/31.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Linear",
        "url": "https://aixplore.in/tool_details?slug=linear",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/39.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Superhuman",
        "url": "https://aixplore.in/tool_details?slug=superhuman",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/24.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "ChatPRD",
        "url": "https://aixplore.in/tool_details?slug=chatprd",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/41.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Granola",
        "url": "https://aixplore.in/tool_details?slug=granola",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/38.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Neo.space",
        "url": "https://aixplore.in/tool_details?slug=neo",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/32.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Yorba",
        "url": "https://aixplore.in/tool_details?slug=yorba",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/29.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      },
      {
        "name": "Fyxer AI",
        "url": "https://aixplore.in/tool_details?slug=fyxer",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/58.png",
        "description": "Leading platform for Productivity.",
        "pricing": "Not Specified",
        "categories": [
          "Productivity"
        ]
      }
    ]
  },
  {
    "category": "LLM Models",
    "tools": [
      {
        "name": "ChatGPT",
        "url": "https://aixplore.in/tool_details?slug=chatgpt",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/14.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Gemini",
        "url": "https://aixplore.in/tool_details?slug=gemini",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/18.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Meta AI",
        "url": "https://aixplore.in/tool_details?slug=meta-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/118.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Claude",
        "url": "https://aixplore.in/tool_details?slug=claude",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/16.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Hugging Face",
        "url": "https://aixplore.in/tool_details?slug=hugging-face",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/89.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "OpenAI Codex",
        "url": "https://aixplore.in/tool_details?slug=openai-codex",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/106.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Ollama",
        "url": "https://aixplore.in/tool_details?slug=ollama",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/116.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Groq",
        "url": "https://aixplore.in/tool_details?slug=groq",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/87.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "DeepSeek",
        "url": "https://aixplore.in/tool_details?slug=deepseek",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/15.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Open Router",
        "url": "https://aixplore.in/tool_details?slug=openrouter",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/86.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "ByteDance Seed",
        "url": "https://aixplore.in/tool_details?slug=bytedance-seed",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/112.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Together",
        "url": "https://aixplore.in/tool_details?slug=together-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/88.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      },
      {
        "name": "Abacus AI",
        "url": "https://aixplore.in/tool_details?slug=abacus-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/119.png",
        "description": "Leading platform for LLM Models.",
        "pricing": "Not Specified",
        "categories": [
          "LLM Models"
        ]
      }
    ]
  },
  {
    "category": "AI Agents",
    "tools": [
      {
        "name": "Devin AI",
        "url": "https://aixplore.in/tool_details?slug=devin",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/26.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://aixplore.in/tool_details?slug=openclaw",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/115.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "Manus",
        "url": "https://aixplore.in/tool_details?slug=manus",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/117.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "Comet",
        "url": "https://aixplore.in/tool_details?slug=comet-browser",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/40.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "Google Antigravity",
        "url": "https://aixplore.in/tool_details?slug=google-antigravity",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/101.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "ByteDance Seed",
        "url": "https://aixplore.in/tool_details?slug=bytedance-seed",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/112.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "21st.dev",
        "url": "https://aixplore.in/tool_details?slug=21st-dev",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/114.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "Abacus AI",
        "url": "https://aixplore.in/tool_details?slug=abacus-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/119.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "Lindy",
        "url": "https://aixplore.in/tool_details?slug=lindy",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/23.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "riff",
        "url": "https://aixplore.in/tool_details?slug=riff",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/2.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      },
      {
        "name": "Emergent",
        "url": "https://aixplore.in/tool_details?slug=emergent",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/13.png",
        "description": "Leading platform for AI Agents.",
        "pricing": "Not Specified",
        "categories": [
          "AI Agents"
        ]
      }
    ]
  },
  {
    "category": "UI/UX Design",
    "tools": [
      {
        "name": "Figma",
        "url": "https://aixplore.in/tool_details?slug=figma",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/97.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Behance",
        "url": "https://aixplore.in/tool_details?slug=behance",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/100.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Dribbble",
        "url": "https://aixplore.in/tool_details?slug=dribbble",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/98.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Framer",
        "url": "https://aixplore.in/tool_details?slug=framer",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/10.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Mobbin",
        "url": "https://aixplore.in/tool_details?slug=mobbin",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/42.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "V0",
        "url": "https://aixplore.in/tool_details?slug=v0",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/3.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Magic Patterns",
        "url": "https://aixplore.in/tool_details?slug=magic-patterns",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/37.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Dualite.dev",
        "url": "https://aixplore.in/tool_details?slug=dualite",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/7.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "UX Pilot",
        "url": "https://aixplore.in/tool_details?slug=ux-pilot",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/99.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      },
      {
        "name": "Stich",
        "url": "https://aixplore.in/tool_details?slug=google-stitch",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/94.png",
        "description": "Leading platform for UI/UX Design.",
        "pricing": "Not Specified",
        "categories": [
          "UI/UX Design"
        ]
      }
    ]
  },
  {
    "category": "Data and Analytics",
    "tools": [
      {
        "name": "Firebase",
        "url": "https://aixplore.in/tool_details?slug=firebase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/96.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "Supabase",
        "url": "https://aixplore.in/tool_details?slug=supabase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/93.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "Appollo",
        "url": "https://aixplore.in/tool_details?slug=apollo-io",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/91.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "Apify",
        "url": "https://aixplore.in/tool_details?slug=apify",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/90.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "RapidAPI",
        "url": "https://aixplore.in/tool_details?slug=rapidapi",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/104.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "Firecrawl",
        "url": "https://aixplore.in/tool_details?slug=firecrawl",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/92.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "Abacus AI",
        "url": "https://aixplore.in/tool_details?slug=abacus-ai",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/119.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "Full Enrich",
        "url": "https://aixplore.in/tool_details?slug=fullenrich",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/53.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      },
      {
        "name": "ZapDigits",
        "url": "https://aixplore.in/tool_details?slug=zapdigits",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/62.png",
        "description": "Leading platform for Data and Analytics.",
        "pricing": "Not Specified",
        "categories": [
          "Data and Analytics"
        ]
      }
    ]
  },
  {
    "category": "Automation",
    "tools": [
      {
        "name": "Zapier",
        "url": "https://aixplore.in/tool_details?slug=zapier",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/22.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "Make.com",
        "url": "https://aixplore.in/tool_details?slug=make",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/21.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "Phantombuster",
        "url": "https://aixplore.in/tool_details?slug=phantombuster",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/69.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://aixplore.in/tool_details?slug=openclaw",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/115.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "Manus",
        "url": "https://aixplore.in/tool_details?slug=manus",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/117.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "n8n.io",
        "url": "https://aixplore.in/tool_details?slug=n8n",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/20.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "Apify",
        "url": "https://aixplore.in/tool_details?slug=apify",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/90.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "Gumloop",
        "url": "https://aixplore.in/tool_details?slug=gumloop",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/46.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      },
      {
        "name": "Firecrawl",
        "url": "https://aixplore.in/tool_details?slug=firecrawl",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/92.png",
        "description": "Leading platform for Automation.",
        "pricing": "Not Specified",
        "categories": [
          "Automation"
        ]
      }
    ]
  },
  {
    "category": "No-Code",
    "tools": [
      {
        "name": "Firebase",
        "url": "https://aixplore.in/tool_details?slug=firebase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/96.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "Webflow",
        "url": "https://aixplore.in/tool_details?slug=webflow",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/54.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "FlutterFlow",
        "url": "https://aixplore.in/tool_details?slug=flutterflow",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/51.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "Supabase",
        "url": "https://aixplore.in/tool_details?slug=supabase",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/93.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "Lovable.dev",
        "url": "https://aixplore.in/tool_details?slug=lovable",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/8.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "Tempo Labs",
        "url": "https://aixplore.in/tool_details?slug=tempo",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/6.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "Stich",
        "url": "https://aixplore.in/tool_details?slug=google-stitch",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/94.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      },
      {
        "name": "Base44",
        "url": "https://aixplore.in/tool_details?slug=base44",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/111.png",
        "description": "Leading platform for No-Code.",
        "pricing": "Not Specified",
        "categories": [
          "No-Code"
        ]
      }
    ]
  },
  {
    "category": "Education and Studies",
    "tools": [
      {
        "name": "Coursera",
        "url": "https://aixplore.in/tool_details?slug=coursera",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/74.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      },
      {
        "name": "Duolingo",
        "url": "https://aixplore.in/tool_details?slug=duolingo",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/82.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      },
      {
        "name": "edX",
        "url": "https://aixplore.in/tool_details?slug=edx",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/76.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      },
      {
        "name": "NotebookLM",
        "url": "https://aixplore.in/tool_details?slug=notebooklm",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/113.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      },
      {
        "name": "DataCamp",
        "url": "https://aixplore.in/tool_details?slug=datacamp",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/75.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      },
      {
        "name": "Brilliant",
        "url": "https://aixplore.in/tool_details?slug=brilliant",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/77.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      },
      {
        "name": "BoodleBox",
        "url": "https://aixplore.in/tool_details?slug=boodlebox",
        "icon": "./aixplore \u2014 Everything AI. One Place._files/56.png",
        "description": "Leading platform for Education and Studies.",
        "pricing": "Not Specified",
        "categories": [
          "Education and Studies"
        ]
      }
    ]
  },
  {
    "category": "Content Creation",
    "tools": [
      {
        "name": "Grammarly",
        "url": "https://grammarly.com",
        "icon": "https://www.google.com/s2/favicons?domain=grammarly.com&sz=128",
        "description": "Leading platform for Content Creation.",
        "pricing": "Not Specified",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Notion",
        "url": "https://notion.so",
        "icon": "https://www.google.com/s2/favicons?domain=notion.so&sz=128",
        "description": "Leading platform for Content Creation.",
        "pricing": "Not Specified",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Jasper AI",
        "url": "https://jasper.ai",
        "icon": "https://www.google.com/s2/favicons?domain=jasper.ai&sz=128",
        "description": "Leading platform for Content Creation.",
        "pricing": "Not Specified",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Wordtune",
        "url": "https://wordtune.com",
        "icon": "https://www.google.com/s2/favicons?domain=wordtune.com&sz=128",
        "description": "Leading platform for Content Creation.",
        "pricing": "Not Specified",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Mangools",
        "url": "https://mangools.com",
        "icon": "https://www.google.com/s2/favicons?domain=mangools.com&sz=128",
        "description": "Leading platform for Content Creation.",
        "pricing": "Not Specified",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Lex",
        "url": "https://lex.page",
        "icon": "https://www.google.com/s2/favicons?domain=lex.page&sz=128",
        "description": "Leading platform for Content Creation.",
        "pricing": "Not Specified",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Copy.ai",
        "url": "https://copy.ai",
        "icon": "https://www.google.com/s2/favicons?domain=copy.ai&sz=128",
        "description": "An AI-powered copywriting assistant that generates marketing copy, blog posts, and social content from simple prompts.",
        "pricing": "Freemium",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Writesonic",
        "url": "https://writesonic.com",
        "icon": "https://www.google.com/s2/favicons?domain=writesonic.com&sz=128",
        "description": "An AI writing platform for generating articles, ads, and product descriptions optimized for SEO.",
        "pricing": "Freemium",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Rytr",
        "url": "https://rytr.me",
        "icon": "https://www.google.com/s2/favicons?domain=rytr.me&sz=128",
        "description": "An affordable AI writing assistant that helps create high-quality content in dozens of use cases and tones.",
        "pricing": "Freemium",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "Sudowrite",
        "url": "https://sudowrite.com",
        "icon": "https://www.google.com/s2/favicons?domain=sudowrite.com&sz=128",
        "description": "An AI writing partner built for fiction authors, helping brainstorm, describe, and expand creative stories.",
        "pricing": "Paid",
        "categories": [
          "Content Creation"
        ]
      },
      {
        "name": "QuillBot",
        "url": "https://quillbot.com",
        "icon": "https://www.google.com/s2/favicons?domain=quillbot.com&sz=128",
        "description": "An AI paraphrasing and grammar tool that rewrites, summarizes, and improves written content instantly.",
        "pricing": "Freemium",
        "categories": [
          "Content Creation"
        ]
      }
    ]
  },
  {
    "category": "Marketing",
    "tools": [
      {
        "name": "Hootsuite",
        "url": "https://hootsuite.com",
        "icon": "https://www.google.com/s2/favicons?domain=hootsuite.com&sz=128",
        "description": "Leading platform for Marketing.",
        "pricing": "Not Specified",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Jasper AI",
        "url": "https://jasper.ai",
        "icon": "https://www.google.com/s2/favicons?domain=jasper.ai&sz=128",
        "description": "Leading platform for Marketing.",
        "pricing": "Not Specified",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Appollo",
        "url": "https://apollo.io",
        "icon": "https://www.google.com/s2/favicons?domain=apollo.io&sz=128",
        "description": "Leading platform for Marketing.",
        "pricing": "Not Specified",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Phantombuster",
        "url": "https://phantombuster.com",
        "icon": "https://www.google.com/s2/favicons?domain=phantombuster.com&sz=128",
        "description": "Leading platform for Marketing.",
        "pricing": "Not Specified",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Screenspace",
        "url": "https://screenspace.io",
        "icon": "https://www.google.com/s2/favicons?domain=screenspace.io&sz=128",
        "description": "Leading platform for Marketing.",
        "pricing": "Not Specified",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Full Enrich",
        "url": "https://fullenrich.com",
        "icon": "https://www.google.com/s2/favicons?domain=fullenrich.com&sz=128",
        "description": "Leading platform for Marketing.",
        "pricing": "Not Specified",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Copy.ai",
        "url": "https://copy.ai",
        "icon": "https://www.google.com/s2/favicons?domain=copy.ai&sz=128",
        "description": "An AI-powered copywriting assistant that generates marketing copy, blog posts, and social content from simple prompts.",
        "pricing": "Freemium",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Surfer SEO",
        "url": "https://surferseo.com",
        "icon": "https://www.google.com/s2/favicons?domain=surferseo.com&sz=128",
        "description": "An AI-driven SEO tool that analyzes top-ranking pages and guides content optimization for better search rankings.",
        "pricing": "Paid",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "AdCreative.ai",
        "url": "https://adcreative.ai",
        "icon": "https://www.google.com/s2/favicons?domain=adcreative.ai&sz=128",
        "description": "An AI ad-generation platform that creates high-converting banner and social ad creatives in seconds.",
        "pricing": "Paid",
        "categories": [
          "Marketing"
        ]
      },
      {
        "name": "Buffer AI Assistant",
        "url": "https://buffer.com",
        "icon": "https://www.google.com/s2/favicons?domain=buffer.com&sz=128",
        "description": "A social media management platform with built-in AI to draft, schedule, and optimize posts across channels.",
        "pricing": "Freemium",
        "categories": [
          "Marketing"
        ]
      }
    ]
  },
  {
    "category": "Business",
    "tools": [
      {
        "name": "Microsoft 365",
        "url": "https://microsoft.com",
        "icon": "https://www.google.com/s2/favicons?domain=microsoft.com&sz=128",
        "description": "Leading platform for Business.",
        "pricing": "Not Specified",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "Linear",
        "url": "https://linear.app",
        "icon": "https://www.google.com/s2/favicons?domain=linear.app&sz=128",
        "description": "Leading platform for Business.",
        "pricing": "Not Specified",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "Appollo",
        "url": "https://apollo.io",
        "icon": "https://www.google.com/s2/favicons?domain=apollo.io&sz=128",
        "description": "Leading platform for Business.",
        "pricing": "Not Specified",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "RapidAPI",
        "url": "https://rapidapi.com",
        "icon": "https://www.google.com/s2/favicons?domain=rapidapi.com&sz=128",
        "description": "Leading platform for Business.",
        "pricing": "Not Specified",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "ZapDigits",
        "url": "https://zapdigits.com",
        "icon": "https://www.google.com/s2/favicons?domain=zapdigits.com&sz=128",
        "description": "Leading platform for Business.",
        "pricing": "Not Specified",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "Notion AI",
        "url": "https://notion.so",
        "icon": "https://www.google.com/s2/favicons?domain=notion.so&sz=128",
        "description": "Notion's built-in AI that drafts, summarizes, and searches across your workspace documents and projects.",
        "pricing": "Freemium",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "HubSpot AI",
        "url": "https://hubspot.com",
        "icon": "https://www.google.com/s2/favicons?domain=hubspot.com&sz=128",
        "description": "HubSpot's AI-powered CRM tools that automate content creation, lead scoring, and customer communication.",
        "pricing": "Freemium",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "Zapier",
        "url": "https://zapier.com",
        "icon": "https://www.google.com/s2/favicons?domain=zapier.com&sz=128",
        "description": "A no-code automation platform that connects thousands of apps, with AI-assisted workflow building.",
        "pricing": "Freemium",
        "categories": [
          "Business"
        ]
      },
      {
        "name": "Clay",
        "url": "https://clay.com",
        "icon": "https://www.google.com/s2/favicons?domain=clay.com&sz=128",
        "description": "An AI-powered data enrichment and outbound workflow tool for go-to-market and sales teams.",
        "pricing": "Freemium",
        "categories": [
          "Business"
        ]
      }
    ]
  },
  {
    "category": "Image Generation",
    "tools": [
      {
        "name": "Meta AI",
        "url": "https://meta.ai",
        "icon": "https://www.google.com/s2/favicons?domain=meta.ai&sz=128",
        "description": "Leading platform for Image Generation.",
        "pricing": "Not Specified",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Freepik",
        "url": "https://freepik.com",
        "icon": "https://www.google.com/s2/favicons?domain=freepik.com&sz=128",
        "description": "Leading platform for Image Generation.",
        "pricing": "Not Specified",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Ideogram",
        "url": "https://ideogram.ai",
        "icon": "https://www.google.com/s2/favicons?domain=ideogram.ai&sz=128",
        "description": "Leading platform for Image Generation.",
        "pricing": "Not Specified",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Kling AI",
        "url": "https://klingai.com",
        "icon": "https://www.google.com/s2/favicons?domain=klingai.com&sz=128",
        "description": "Leading platform for Image Generation.",
        "pricing": "Not Specified",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Midjourney",
        "url": "https://midjourney.com",
        "icon": "https://www.google.com/s2/favicons?domain=midjourney.com&sz=128",
        "description": "The AI art generator famous for producing highly stylized, painterly images from text prompts via Discord and the web.",
        "pricing": "Paid",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "DALL-E",
        "url": "https://openai.com/dall-e-3",
        "icon": "https://www.google.com/s2/favicons?domain=openai.com&sz=128",
        "description": "OpenAI's image generation model that creates detailed, photorealistic images and art from natural language descriptions.",
        "pricing": "Freemium",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Stable Diffusion",
        "url": "https://stability.ai",
        "icon": "https://www.google.com/s2/favicons?domain=stability.ai&sz=128",
        "description": "An open-source image generation model from Stability AI that can run locally or via API for full creative control.",
        "pricing": "Free",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Adobe Firefly",
        "url": "https://firefly.adobe.com",
        "icon": "https://www.google.com/s2/favicons?domain=firefly.adobe.com&sz=128",
        "description": "Adobe's generative AI model integrated across Creative Cloud for commercially safe image and effects generation.",
        "pricing": "Freemium",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Leonardo AI",
        "url": "https://leonardo.ai",
        "icon": "https://www.google.com/s2/favicons?domain=leonardo.ai&sz=128",
        "description": "A creative generation platform offering fine-tuned models for game assets, concept art, and production-ready images.",
        "pricing": "Freemium",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Playground AI",
        "url": "https://playground.com",
        "icon": "https://www.google.com/s2/favicons?domain=playground.com&sz=128",
        "description": "A free-to-use AI image editor and generator with an intuitive canvas for creating and remixing visuals.",
        "pricing": "Freemium",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Flux",
        "url": "https://blackforestlabs.ai",
        "icon": "https://www.google.com/s2/favicons?domain=blackforestlabs.ai&sz=128",
        "description": "A state-of-the-art open-weight image generation model from Black Forest Labs known for prompt accuracy and detail.",
        "pricing": "Freemium",
        "categories": [
          "Image Generation"
        ]
      },
      {
        "name": "Recraft",
        "url": "https://recraft.ai",
        "icon": "https://www.google.com/s2/favicons?domain=recraft.ai&sz=128",
        "description": "An AI design tool for generating vector images, icons, and brand-consistent illustrations.",
        "pricing": "Freemium",
        "categories": [
          "Image Generation"
        ]
      }
    ]
  },
  {
    "category": "Presentations",
    "tools": [
      {
        "name": "Gamma",
        "url": "https://gamma.app",
        "icon": "https://www.google.com/s2/favicons?domain=gamma.app&sz=128",
        "description": "Leading platform for Presentations.",
        "pricing": "Not Specified",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Manus",
        "url": "https://manus.im",
        "icon": "https://www.google.com/s2/favicons?domain=manus.im&sz=128",
        "description": "Leading platform for Presentations.",
        "pricing": "Not Specified",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Beautiful.ai",
        "url": "https://beautiful.ai",
        "icon": "https://www.google.com/s2/favicons?domain=beautiful.ai&sz=128",
        "description": "Leading platform for Presentations.",
        "pricing": "Not Specified",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Screenspace",
        "url": "https://screenspace.io",
        "icon": "https://www.google.com/s2/favicons?domain=screenspace.io&sz=128",
        "description": "Leading platform for Presentations.",
        "pricing": "Not Specified",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Tome",
        "url": "https://tome.app",
        "icon": "https://www.google.com/s2/favicons?domain=tome.app&sz=128",
        "description": "An AI-native storytelling format that generates narrative decks and pages from a single prompt.",
        "pricing": "Freemium",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Canva AI",
        "url": "https://canva.com",
        "icon": "https://www.google.com/s2/favicons?domain=canva.com&sz=128",
        "description": "Canva's Magic Design suite that auto-generates presentations, layouts, and visuals from text prompts.",
        "pricing": "Freemium",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Decktopus",
        "url": "https://decktopus.com",
        "icon": "https://www.google.com/s2/favicons?domain=decktopus.com&sz=128",
        "description": "An AI presentation generator that builds complete, ready-to-present decks from a short brief.",
        "pricing": "Freemium",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "SlidesAI",
        "url": "https://slidesai.io",
        "icon": "https://www.google.com/s2/favicons?domain=slidesai.io&sz=128",
        "description": "A Google Slides add-on that converts text into fully designed slide decks in seconds.",
        "pricing": "Freemium",
        "categories": [
          "Presentations"
        ]
      },
      {
        "name": "Pitch",
        "url": "https://pitch.com",
        "icon": "https://www.google.com/s2/favicons?domain=pitch.com&sz=128",
        "description": "A collaborative presentation tool with AI-assisted design suggestions built for teams.",
        "pricing": "Freemium",
        "categories": [
          "Presentations"
        ]
      }
    ]
  },
  {
    "category": "Art",
    "tools": [
      {
        "name": "Behance",
        "url": "https://behance.net",
        "icon": "https://www.google.com/s2/favicons?domain=behance.net&sz=128",
        "description": "Leading platform for Art.",
        "pricing": "Not Specified",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "Freepik",
        "url": "https://freepik.com",
        "icon": "https://www.google.com/s2/favicons?domain=freepik.com&sz=128",
        "description": "Leading platform for Art.",
        "pricing": "Not Specified",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "Dribbble",
        "url": "https://dribbble.com",
        "icon": "https://www.google.com/s2/favicons?domain=dribbble.com&sz=128",
        "description": "Leading platform for Art.",
        "pricing": "Not Specified",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "Ideogram",
        "url": "https://ideogram.ai",
        "icon": "https://www.google.com/s2/favicons?domain=ideogram.ai&sz=128",
        "description": "Leading platform for Art.",
        "pricing": "Not Specified",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "NightCafe",
        "url": "https://nightcafe.studio",
        "icon": "https://www.google.com/s2/favicons?domain=nightcafe.studio&sz=128",
        "description": "A community-driven AI art generator with multiple models and a social feed for sharing creations.",
        "pricing": "Freemium",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "Artbreeder",
        "url": "https://artbreeder.com",
        "icon": "https://www.google.com/s2/favicons?domain=artbreeder.com&sz=128",
        "description": "A collaborative tool for blending and evolving images into new AI-generated art and character designs.",
        "pricing": "Freemium",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "Scenario",
        "url": "https://scenario.com",
        "icon": "https://www.google.com/s2/favicons?domain=scenario.com&sz=128",
        "description": "An AI art generation platform for game studios to create custom, style-consistent game assets.",
        "pricing": "Paid",
        "categories": [
          "Art"
        ]
      },
      {
        "name": "Leonardo AI",
        "url": "https://leonardo.ai",
        "icon": "https://www.google.com/s2/favicons?domain=leonardo.ai&sz=128",
        "description": "A creative generation platform offering fine-tuned models for game assets, concept art, and production-ready images.",
        "pricing": "Freemium",
        "categories": [
          "Art"
        ]
      }
    ]
  },
  {
    "category": "Search Engine",
    "tools": [
      {
        "name": "Perplexity.ai",
        "url": "https://perplexity.ai",
        "icon": "https://www.google.com/s2/favicons?domain=perplexity.ai&sz=128",
        "description": "Leading platform for Search Engine.",
        "pricing": "Not Specified",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "You.com",
        "url": "https://you.com",
        "icon": "https://www.google.com/s2/favicons?domain=you.com&sz=128",
        "description": "Leading platform for Search Engine.",
        "pricing": "Not Specified",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Comet",
        "url": "https://comet.com",
        "icon": "https://www.google.com/s2/favicons?domain=comet.com&sz=128",
        "description": "Leading platform for Search Engine.",
        "pricing": "Not Specified",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Exa AI",
        "url": "https://exa.ai",
        "icon": "https://www.google.com/s2/favicons?domain=exa.ai&sz=128",
        "description": "Leading platform for Search Engine.",
        "pricing": "Not Specified",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "SearchGPT",
        "url": "https://openai.com/index/searchgpt",
        "icon": "https://www.google.com/s2/favicons?domain=openai.com&sz=128",
        "description": "OpenAI's real-time, conversational search experience built into ChatGPT with cited web sources.",
        "pricing": "Freemium",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Liner AI",
        "url": "https://getliner.com",
        "icon": "https://www.google.com/s2/favicons?domain=getliner.com&sz=128",
        "description": "An AI search copilot that highlights and summarizes trustworthy web sources into concise, cited answers.",
        "pricing": "Freemium",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "ChatGPT Atlas",
        "url": "https://openai.com/atlas",
        "icon": "https://www.google.com/s2/favicons?domain=openai.com&sz=128",
        "description": "OpenAI's AI-native web browser built around ChatGPT for searching, browsing, and taking action on the web.",
        "pricing": "Freemium",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Microsoft Bing",
        "url": "https://bing.com",
        "icon": "https://www.google.com/s2/favicons?domain=bing.com&sz=128",
        "description": "Microsoft's search engine with Copilot AI built in for conversational search and summarized results.",
        "pricing": "Free",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Genspark AI Browser",
        "url": "https://genspark.ai",
        "icon": "https://www.google.com/s2/favicons?domain=genspark.ai&sz=128",
        "description": "An AI browser and search agent that generates custom answer pages and automates web-based tasks.",
        "pricing": "Freemium",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Semantic Scholar",
        "url": "https://semanticscholar.org",
        "icon": "https://www.google.com/s2/favicons?domain=semanticscholar.org&sz=128",
        "description": "A free, AI-powered research tool for scientific literature search and citation discovery.",
        "pricing": "Free",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Scite.ai",
        "url": "https://scite.ai",
        "icon": "https://www.google.com/s2/favicons?domain=scite.ai&sz=128",
        "description": "An AI research tool that shows how published papers have been cited, supported, or contradicted by other work.",
        "pricing": "Freemium",
        "categories": [
          "Search Engine"
        ]
      },
      {
        "name": "Globe Explorer AI",
        "url": "https://explorer.globe.engineer",
        "icon": "https://www.google.com/s2/favicons?domain=explorer.globe.engineer&sz=128",
        "description": "An AI search tool that turns any topic into an interactive, explorable knowledge map instead of a list of links.",
        "pricing": "Free",
        "categories": [
          "Search Engine"
        ]
      }
    ]
  },
  {
    "category": "Video Generators",
    "tools": [
      {
        "name": "HeyGen",
        "url": "https://heygen.com",
        "icon": "https://www.google.com/s2/favicons?domain=heygen.com&sz=128",
        "description": "Leading platform for Video Generators.",
        "pricing": "Not Specified",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Restream",
        "url": "https://restream.io",
        "icon": "https://www.google.com/s2/favicons?domain=restream.io&sz=128",
        "description": "Leading platform for Video Generators.",
        "pricing": "Not Specified",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Kling AI",
        "url": "https://klingai.com",
        "icon": "https://www.google.com/s2/favicons?domain=klingai.com&sz=128",
        "description": "Leading platform for Video Generators.",
        "pricing": "Not Specified",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Higgsfield AI",
        "url": "https://higgsfield.ai",
        "icon": "https://www.google.com/s2/favicons?domain=higgsfield.ai&sz=128",
        "description": "Leading platform for Video Generators.",
        "pricing": "Not Specified",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Runway",
        "url": "https://runwayml.com",
        "icon": "https://www.google.com/s2/favicons?domain=runwayml.com&sz=128",
        "description": "A leading AI video generation and editing suite, known for its Gen-3 Alpha text-to-video model.",
        "pricing": "Freemium",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Pika",
        "url": "https://pika.art",
        "icon": "https://www.google.com/s2/favicons?domain=pika.art&sz=128",
        "description": "An AI video generator that turns text, images, and ideas into short, stylized video clips.",
        "pricing": "Freemium",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Synthesia",
        "url": "https://synthesia.io",
        "icon": "https://www.google.com/s2/favicons?domain=synthesia.io&sz=128",
        "description": "An AI video platform that generates professional presenter videos from text using realistic digital avatars.",
        "pricing": "Paid",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Sora",
        "url": "https://openai.com/sora",
        "icon": "https://www.google.com/s2/favicons?domain=openai.com&sz=128",
        "description": "OpenAI's text-to-video model that generates realistic and imaginative video scenes from text prompts.",
        "pricing": "Paid",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Luma Dream Machine",
        "url": "https://lumalabs.ai/dream-machine",
        "icon": "https://www.google.com/s2/favicons?domain=lumalabs.ai&sz=128",
        "description": "A fast, high-quality AI video model from Luma Labs that generates realistic motion from text or images.",
        "pricing": "Freemium",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "InVideo AI",
        "url": "https://invideo.io",
        "icon": "https://www.google.com/s2/favicons?domain=invideo.io&sz=128",
        "description": "An AI video editor that turns a text prompt into a fully edited video complete with voiceover and stock footage.",
        "pricing": "Freemium",
        "categories": [
          "Video Generators"
        ]
      },
      {
        "name": "Pictory",
        "url": "https://pictory.ai",
        "icon": "https://www.google.com/s2/favicons?domain=pictory.ai&sz=128",
        "description": "An AI tool that automatically converts long-form content and scripts into short, shareable branded videos.",
        "pricing": "Paid",
        "categories": [
          "Video Generators"
        ]
      }
    ]
  },
  {
    "category": "Human Resources",
    "tools": [
      {
        "name": "AIApply",
        "url": "https://www.aixploria.com/out/AIApply",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/aiapply.png",
        "description": "A multi-tasking tool to increase your chances of finding a job: CV creation, covering letters, job interview practice, etc.",
        "pricing": "Free Trial",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "JobCopilot",
        "url": "https://www.aixploria.com/out/JobCopilot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/jobcopilot.png",
        "description": "An AI assistant that automates your job search by applying up to 50 times a day to 50,000 job boards. It generates personalized cover letters, optimizes your applications and trains you for job interviews",
        "pricing": "Paid",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "RemotePeople",
        "url": "https://remotepeople.com/tools/ai-job-description-generator/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/remotepeople.png",
        "description": "An AI job description generator that helps you create accurate, detailed and compelling job offers. Customize content, comply with legal standards and attract the best candidates fast",
        "pricing": "Free",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "Workleap",
        "url": "https://www.aixploria.com/out/Workleap",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/workleap.png",
        "description": "A complete HR platform that makes your employees' day-to-day work easier. Manage the performance, engagement and development of your teams via intuitive AI tools adapted to hybrid working",
        "pricing": "Free Trial",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "Leet Resumes",
        "url": "https://www.aixploria.com/out/LeetResumes",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/leet-resumes.png",
        "description": "Upload your CV and you'll receive an improved copy, completely rewritten by the AI. Compatible with doc, pdf and docx files",
        "pricing": "Free",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "Teal Resume Builder",
        "url": "https://www.aixploria.com/out/TealResumeBuilder",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/teal-resume-builder.png",
        "description": "Use AI to create a highly professional and attractive CV. Pre-made templates for immediate use.",
        "pricing": "Freemium",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "UseResume AI",
        "url": "https://useresume.ai/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/useresume-ai.png",
        "description": "Generate professional CVs and cover letters in minutes with AI. Highlight your key skills and experience to maximize your chances of interview",
        "pricing": "Freemium",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "AI Career Coach",
        "url": "https://www.aixploria.com/out/AICareerCoach",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-career-coach.png",
        "description": "Benefit from personalized career coaching thanks to AI. Explore career paths, prepare for interviews and get advice tailored to your profile (student or retraining)",
        "pricing": "Free",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "Resume Worded",
        "url": "https://www.aixploria.com/out/ResumeWorded",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/resume-worded.png",
        "description": "Easily improve your LinkedIn profile page and be more attractive to recruiters",
        "pricing": "Freemium",
        "categories": [
          "Human Resources"
        ]
      },
      {
        "name": "HumanFlow",
        "url": "https://humanflow.app/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/humanflow.png",
        "description": "An AI assistant dedicated to recruitment that helps sort resumes, analyze profiles, and prioritize the best talent more quickly.",
        "pricing": "Freemium",
        "categories": [
          "Human Resources"
        ]
      }
    ]
  },
  {
    "category": "E-mail",
    "tools": [
      {
        "name": "Klaviyo",
        "url": "https://www.aixploria.com/out/Klaviyo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/klaviyo.png",
        "description": "Automate your marketing campaigns with AI. Send ultra-personalized e-mails and SMS using real-time customer data",
        "pricing": "Paid",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "MailerLite",
        "url": "https://www.aixploria.com/out/MailerLite",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mailerlite.png",
        "description": "A professional e-mail marketing platform powered by AI. Create newsletters, automate campaigns and analyze performance with intuitive tools",
        "pricing": "Freemium",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "GetResponse",
        "url": "https://www.aixploria.com/out/GetResponse",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/getresponse.png",
        "description": "An all-in-one AI-enhanced marketing platform that automates your emails, creates personalized content and optimizes your campaigns to maximize conversions",
        "pricing": "Free Trial",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "HoppyCopy",
        "url": "https://www.aixploria.com/out/HoppyCopy",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hoppycopy.png",
        "description": "Write high-impact e-mail campaigns in the blink of an eye, thanks to AI. Save precious time with more than 50 templates optimized to meet your needs",
        "pricing": "Freemium",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "Notion Mail",
        "url": "https://www.aixploria.com/out/NotionMail",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/notion-mail.png",
        "description": "An AI inbox that connects to your Gmail and can perform all kinds of tasks: write e-mails, organize your messages, schedule meetings and more",
        "pricing": "Free",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "Free AI Email Writer",
        "url": "https://www.aixploria.com/out/FreeAIEmailWriter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/g--n--rateur-e-mails.png",
        "description": "An AI tool that writes relevant prospecting e-mails on a large scale, free of charge, and automates the sending of your e-mails. Use predefined, professional templates",
        "pricing": "Free",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "Benchmark Email",
        "url": "https://www.aixploria.com/out/BenchmarkEmail",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/benchmark-email.png",
        "description": "Create professional and attractive emails",
        "pricing": "Free",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "Hostinger Reach",
        "url": "https://www.hostg.xyz/aff_c?offer_id=48&aff_id=184546&url_id=5071",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hostinger-reach.png",
        "description": "Create and send professional email marketing campaigns without any technical setup: connect your domain, specify the goal of your message, and instantly get a complete template with layout, content, and design",
        "pricing": "Paid",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "beehiiv AI",
        "url": "https://www.aixploria.com/out/beehiivAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/beehiiv-ai.png",
        "description": "Improve and accelerate your newsletter content creation with writing, editing, translation and monetization tools",
        "pricing": "Freemium",
        "categories": [
          "E-mail"
        ]
      },
      {
        "name": "Superhuman",
        "url": "https://www.aixploria.com/out/Superhuman",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/superhuman.png",
        "description": "This premium email client uses AI to process your inbox twice as fast. AI drafts emails in your style based on your previous messages, summarizes long conversations, and automatically sorts or archives your emails according to your own rules.",
        "pricing": "Paid",
        "categories": [
          "E-mail"
        ]
      }
    ]
  },
  {
    "category": "Logo creation",
    "tools": [
      {
        "name": "Looka",
        "url": "https://www.aixploria.com/out/Looka",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/looka.png",
        "description": "A powerful AI logo generator and visual identity platform. Create professional logos, customize your designs and access over 300 templates for marketing materials, from business cards to social networks",
        "pricing": "Freemium",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "Ideogram 3.0",
        "url": "https://www.aixploria.com/out/Ideogram3.0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ideogram-3-0.png",
        "description": "An image generator capable of creating impressive illustrations and integrating text. Ideal for creating logos, storyboards, advertising banners, etc.",
        "pricing": "Free",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "AI Logo by Fiverr",
        "url": "https://www.aixploria.com/out/AILogobyFiverr",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/03/fiverr-icon.webp",
        "description": "Design a logo in moments with this AI-powered logo generator. Fast, easy and high-quality design",
        "pricing": "Freemium",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "Adobe Free Logo Maker",
        "url": "https://www.aixploria.com/out/AdobeFreeLogoMaker",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/08/adobe-express.jpg",
        "description": "An online logo maker with thousands of customizable templates. Create your visual identity quickly with simple design tools and a free icon library",
        "pricing": "Free",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "Shopify Logo Free",
        "url": "https://www.aixploria.com/out/ShopifyLogoFree",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/shopify-logo-free.png",
        "description": "Quickly create a free logo: thousands of professional templates to customize, high-resolution download included. No hidden fees, instant access",
        "pricing": "Free",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "Arvin AI Logo Maker",
        "url": "https://arvin.chat/feature/ai-logo-designer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/arvin-ai-logo-maker.png",
        "description": "An AI tool for designing a personalized, professional-quality logo in a few clicks. Easily customize text, images and mockups with 10,000+ templates",
        "pricing": "Free",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "Logo Maker Namecheap",
        "url": "https://www.aixploria.com/out/LogoMakerNamecheap",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/namecheap.png",
        "description": "An online logo creator that generates designs in 5 minutes. Choose from thousands of fonts and icons, download your logo in PNG and SVG for free",
        "pricing": "Free",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "insMind AI Logo",
        "url": "https://www.insmind.com/ai-logo-generator/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/insmind-ai-logo.png",
        "description": "A free online AI logo generator. Enter your brand name and slogan, and our AI will generate multiple logo options for you to customize further",
        "pricing": "Free",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "LogoAI",
        "url": "https://www.aixploria.com/out/LogoAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/logoai.png",
        "description": "An incredible AI that can create stunning logos for all kinds of projects in just a few clicks",
        "pricing": "Paid",
        "categories": [
          "Logo creation"
        ]
      },
      {
        "name": "Design.com",
        "url": "https://www.design.com/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/design-com.png",
        "description": "Easily create logos, business cards, social networking banners or e-mail signatures with thousands of customizable templates. This premium platform features a host of AI tools dedicated to design",
        "pricing": "Freemium",
        "categories": [
          "Logo creation"
        ]
      }
    ]
  },
  {
    "category": "Websites & Design",
    "tools": [
      {
        "name": "Hostinger AI Hub",
        "url": "https://www.hostg.xyz/aff_c?offer_id=48&aff_id=184546&url_id=5336",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hostinger-ai-hub.png",
        "description": "Create a complete website in minutes using AI, without needing to know how to code. Design, text, images, SEO, and integrated e-commerce: everything is ready, all you have to do is publish",
        "pricing": "Paid",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Canva AI",
        "url": "https://www.aixploria.com/out/CanvaAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/canva-ai.png",
        "description": "A set of tools for digital creation and visual design. Quickly create all your visuals with an AI-based platform",
        "pricing": "Freemium",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Lovable",
        "url": "https://www.aixploria.com/out/Lovable",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lovable.png",
        "description": "Create websites and applications faster than with any other AI tool, with no technical expertise required. This tool turns anyone into a SaaS developer",
        "pricing": "Freemium",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Framer AI",
        "url": "https://www.aixploria.com/out/FramerAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/framer-ai.png",
        "description": "Create and publish a website instantly without coding. Customization and inspiration from free templates",
        "pricing": "Freemium",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Notion Sites",
        "url": "https://www.aixploria.com/out/NotionSites",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/notion-sites.png",
        "description": "Create an elegant website without coding, using an intuitive AI tool. Easily customize your pages, add dynamic content and publish everything quickly",
        "pricing": "Free",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Emergent AI",
        "url": "https://www.aixploria.com/out/EmergentAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/emergent-ai.png",
        "description": "Build full-stack apps from your ideas with AI agents who code, test and deploy for you. Create complete websites, AI apps, games and automated tools simply by describing your project",
        "pricing": "Freemium",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Base44",
        "url": "https://www.aixploria.com/out/Base44",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/base44.png",
        "description": "Create full applications without coding. This tool integrates database management, authentication, messaging and analysis functions. So you can quickly turn your ideas into functional products.",
        "pricing": "Freemium",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "AI Website Generator",
        "url": "https://www.aixploria.com/out/AIWebsiteGenerator",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/04/HubSpot-fav.png",
        "description": "Create a professional website in minutes from a short description of your project. This website generator is driven by HubSpot's powerful AI",
        "pricing": "Free Trial",
        "categories": [
          "Websites & Design"
        ]
      },
      {
        "name": "Hostinger Horizons",
        "url": "https://www.hostg.xyz/aff_c?offer_id=940&aff_id=184546",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hostinger-horizons.png",
        "description": "Bring your web app ideas to life without writing a single line of code. Simply describe your project, and AI will generate the design, features, and complete online launch for you",
        "pricing": "Freemium",
        "categories": [
          "Websites & Design"
        ]
      }
    ]
  },
  {
    "category": "Life Assistants",
    "tools": [
      {
        "name": "Microsoft Copilot",
        "url": "https://www.aixploria.com/out/MicrosoftCopilot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/microsoft-copilot.png",
        "description": "A versatile assistant to help you every day. Get customized solutions and useful information at any time",
        "pricing": "Free",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "OpenClaw",
        "url": "https://www.aixploria.com/out/OpenClaw",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/openclaw.png",
        "description": "A locally hosted open-source personal AI assistant (Mac/Windows/Linux) with persistent memory and full system access. Control it via WhatsApp, Telegram, Discord, Slack, iMessage, or Signal to automate your workflows",
        "pricing": "Free",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "Roast Dating",
        "url": "https://www.aixploria.com/out/RoastDating",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/roast-dating.png",
        "description": "Quickly increase your number of matches in applications like Tinder, Hinge or Bumble",
        "pricing": "Freemium",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "AI HairStyles",
        "url": "https://www.aixploria.com/out/AIHairStyles",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-hairstyles.png",
        "description": "Try out new hairstyles from one of your selfies with an AI that knows trends and fashion",
        "pricing": "Paid",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "Gemini Personal Intelligence",
        "url": "https://www.aixploria.com/out/GeminiPersonalIntelligence",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gemini-personal-intelligence.png",
        "description": "A next-generation mobile AI assistant that truly understands you and performs tasks across all your Google apps. It can manage your emails, calls, messages, reminders, control your smart home, and much more",
        "pricing": "Free",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "Ask Layla",
        "url": "https://www.aixploria.com/out/AskLayla",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ask-layla.png",
        "description": "An AI travel agent to find the best destinations. It can book flights and hotels, find personalized activity ideas, plan itineraries and much more",
        "pricing": "Free",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "Blush AI",
        "url": "https://www.aixploria.com/out/BlushAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/blush-ai.png",
        "description": "An AI-powered dating simulator that provides a safe space to learn how to seduce. Improves self-confidence and understanding of relationships",
        "pricing": "Free",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "Tattoos AI",
        "url": "https://www.aixploria.com/out/TattoosAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/tattoos-ai.png",
        "description": "Design the tattoo of your dreams with an intelligence that masters the art of tattooing to perfection",
        "pricing": "Freemium",
        "categories": [
          "Life Assistants"
        ]
      },
      {
        "name": "Doppl by Google",
        "url": "https://www.aixploria.com/out/DopplbyGoogle",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/doppl-by-google.png",
        "description": "Try on virtually any garment on your digital avatar with AI. Upload an outfit photo from social networks or stores, then visualize the rendering with realistic video animations and explore your style",
        "pricing": "Free",
        "categories": [
          "Life Assistants"
        ]
      }
    ]
  },
  {
    "category": "Memory",
    "tools": [
      {
        "name": "QuizLet",
        "url": "https://www.aixploria.com/out/QuizLet",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/quizlet.png",
        "description": "Learn more easily with educational games, flashcards and practice quizzes. Available on browser and mobile",
        "pricing": "Free",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Rewind AI",
        "url": "https://www.aixploria.com/out/RewindAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rewind-ai.png",
        "description": "Search for anything you may have seen or heard from a prompt (MAC)",
        "pricing": "Freemium",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Reflect AI",
        "url": "https://www.aixploria.com/out/ReflectAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/reflect-ai.png",
        "description": "Use AI to improve your note-taking and writing skills",
        "pricing": "Freemium",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Memories.ai",
        "url": "https://www.aixploria.com/out/Memories.ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/memories-ai.png",
        "description": "The world's first AI visual memory model. Analyze large-scale videos, gain actionable insights for safety, marketing and content creation",
        "pricing": "Free",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Mem AI",
        "url": "https://www.aixploria.com/out/MemAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/mem-ai.png",
        "description": "Let this AI take control, it automatically organizes and classifies all your project data",
        "pricing": "Freemium",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "myNeutron AI Memory",
        "url": "https://myneutron.ai/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/myneutron-ai-memory.png",
        "description": "Keep your notes, emails, and web pages in one place that you can access with just one click. Find everything you're looking for with semantic search and get smart summaries",
        "pricing": "Free",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Memoru Flashcards",
        "url": "https://www.aixploria.com/out/MemoruFlashcards",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/memoru-flashcards.png",
        "description": "An AI-assisted flashcard system to enhance your learning in any subject. With personalised objectives, quizzes, etc.",
        "pricing": "Free",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Glasp",
        "url": "https://www.aixploria.com/out/Glasp",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/glasp.png",
        "description": "Generate compelling text for content creation and newsletters",
        "pricing": "Free",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "Talknotes",
        "url": "https://www.aixploria.com/out/Talknotes",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/talknotes.png",
        "description": "An AI that takes handwritten notes of everything you say (speech and voice recordings). Transcription available in 50 languages",
        "pricing": "Free",
        "categories": [
          "Memory"
        ]
      },
      {
        "name": "MinutesLink",
        "url": "https://minuteslink.com/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/minuteslink.png",
        "description": "An AI tool that automates meeting notes with accurate transcripts, audio recordings, and shareable minutes. Simplify your meetings effortlessly",
        "pricing": "Freemium",
        "categories": [
          "Memory"
        ]
      }
    ]
  },
  {
    "category": "Finance",
    "tools": [
      {
        "name": "Intuit Assist",
        "url": "https://www.aixploria.com/out/IntuitAssist",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/intuit-assist.png",
        "description": "An intelligent financial assistant using powerful AI. Manage your taxes, accounting and marketing with TurboTax, QuickBooks and Mailchimp. Get smart recommendations",
        "pricing": "Freemium",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "PionexGPT",
        "url": "https://www.aixploria.com/out/PionexGPT",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pionexgpt.png",
        "description": "A cryptocurrency exchange platform offering automatic trading bots",
        "pricing": "Free",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "Google Finance AI",
        "url": "https://www.aixploria.com/out/GoogleFinanceAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/google-finance-ai.png",
        "description": "Track your stocks, cryptocurrencies, and markets in real time with AI-powered visualizations and charts that summarize financial news based on your interests. A conversational search bar lets you ask questions about any security and explore historical data",
        "pricing": "Free",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "AIR by Revolut",
        "url": "https://www.aixploria.com/out/AIRbyRevolut",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/air-by-revolut.png",
        "description": "Manage your finances using natural language, right in the Revolut app. This AI assistant analyzes your spending, tracks your investments, manages your subscriptions, blocks a lost card, and helps you plan your trips (budget, eSIM) with just a few messages",
        "pricing": "Free",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "BlackRock AI Labs",
        "url": "https://www.aixploria.com/out/BlackRockAILabs",
        "icon": "https://www.aixploria.com/wp-content/uploads/2025/07/blackrock-ai-labs-favicon.png",
        "description": "Explore the latest research in artificial intelligence applied to finance: machine learning, portfolio optimization and predictive analytics developed by one of the world's leading investment firms",
        "pricing": "Free",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "Finchat.io",
        "url": "https://www.aixploria.com/out/Finchat.io",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/finchat-io.png",
        "description": "Use ChatGPT's capabilities to analyze, invest or get answers about a company",
        "pricing": "Free",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "AInvest",
        "url": "https://www.aixploria.com/out/AInvest",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ainvest.png",
        "description": "A tool for identifying and analyzing listed stocks according to various criteria. Features filtering options and several classification methods",
        "pricing": "Freemium",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "LivePlan",
        "url": "https://www.aixploria.com/out/LivePlan",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/03/liveplan-ai.png",
        "description": "Make your business dream come true with intuitive AI tools. Create a solid business plan and financial forecast without complex spreadsheets",
        "pricing": "Paid",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "Danelfin",
        "url": "https://www.aixploria.com/out/Danelfin",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/danelfin.png",
        "description": "An AI-powered stock analysis platform. Find trending stocks, access rankings and discover new trading ideas",
        "pricing": "Free",
        "categories": [
          "Finance"
        ]
      },
      {
        "name": "PortfolioPilot",
        "url": "https://www.aixploria.com/out/PortfolioPilot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/portfoliopilot.png",
        "description": "Optimize your investment portfolio with an AI advisor: 360\u00b0 analysis, personalized recommendations, trends, etc. Technology inspired by hedge funds",
        "pricing": "Freemium",
        "categories": [
          "Finance"
        ]
      }
    ]
  },
  {
    "category": "Healthcare",
    "tools": [
      {
        "name": "Woebot Health",
        "url": "https://www.aixploria.com/out/WoebotHealth",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/woebot-health.png",
        "description": "A personal coach who supports you mentally",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Beducated",
        "url": "https://www.aixploria.com/out/Beducated",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/beducated.png",
        "description": "An AI conversational agent to improve your physical and sexual attractiveness. Get to know your body better",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Google MedASR",
        "url": "https://www.aixploria.com/out/GoogleMedASR",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/google-medasr.png",
        "description": "Easily transcribe medical dictations and exchanges between doctors and patients. The system is based on a voice recognition model with 105 million parameters, trained on 5,000 hours of medical data covering radiology and internal medicine",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Be My Eyes",
        "url": "https://www.aixploria.com/out/BeMyEyes",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/be-my-eyes.png",
        "description": "Free application linking visually impaired people to volunteers for real-time visual assistance",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Facial Assessment Tool",
        "url": "https://www.aixploria.com/out/FacialAssessmentTool",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/facial-assessment-tool.png",
        "description": "An AI that analyzes your face and gives you cosmetic advice to beautify you",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "MedLM by Google",
        "url": "https://www.aixploria.com/out/MedLMbyGoogle",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/medlm-by-google.png",
        "description": "MedLM provides specialised AI models for the healthcare sector. Highly capable of answering complex medical questions",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "ChatGPT Health",
        "url": "https://www.aixploria.com/out/ChatGPTHealth",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/chatgpt-health.png",
        "description": "A specialized version that helps interpret medical records, prepare for consultations, and find fitness advice by connecting to Apple Health. The assistant answers medical questions from over 200 million users. Available on the waitlist",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Claude Healthcare",
        "url": "https://www.aixploria.com/out/ClaudeHealthcare",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/claude-healthcare.png",
        "description": "An AI solution dedicated to healthcare professionals that automates prior authorizations, insurance appeal reviews, clinical documentation, and patient coordination. The assistant can also connect to CMS, ICD-10, NPI Registry, and PubMed databases",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Tempus AI",
        "url": "https://www.aixploria.com/out/TempusAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/tempus-ai.png",
        "description": "A platform that dramatically improves healthcare by analyzing biomedical data using AI. Optimize personalized treatments and discover new therapeutic targets",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Sugar Free",
        "url": "https://www.aixploria.com/out/SugarFree",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sugar-free.png",
        "description": "An intelligent scanner capable of detecting sugar levels in any food. It also provides personalized recommendations and helps overcome sugar addiction",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "QuitPorn",
        "url": "https://quitporn.ai/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/quitporn.png",
        "description": "An AI assistant to help you overcome porn addiction. Get personalized advice, impulse management strategies and 24/7 support to get your sex life back on track",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Medeloop",
        "url": "https://www.aixploria.com/out/Medeloop",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/medeloop.png",
        "description": "A suite of AI tools dedicated to medical research that automates grant writing, clinical study management, data analysis and scientific manuscript publication",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Friend AI",
        "url": "https://www.aixploria.com/out/FriendAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/04/website-icon-default.webp",
        "description": "An AI companion for overcoming loneliness that can interact emotionally with you via a discreet pendant. An original concept focused on well-being",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Glow AI",
        "url": "https://www.aixploria.com/out/GlowAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/glow-ai.png",
        "description": "An AI assistant that will take care of your skin and generate adapted programs",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Healing Journey AI",
        "url": "https://healingjourney.ai/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/healing-journey-ai.png",
        "description": "An AI therapist available 24/7 to support you. Benefit from non-judgmental psychological support, with over a billion insights and professional supervision, in a secure and confidential setting",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Visual Field Test",
        "url": "https://visualfieldtest.com/",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/01/visual-field-test-favicon.webp",
        "description": "Test your peripheral vision directly online with a series of interactive grids that assess the extent and responsiveness of your visual field. At the end of the test, you will receive feedback and a visualization of your results",
        "pricing": "Free Trial",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "TripleTen Burnout Test",
        "url": "https://tripleten.com/tools/burnout-test/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/tripleten-burnout-test.png",
        "description": "Check your mental health at work with AI. This interactive questionnaire assesses your stress levels and detects early signs of burnout to help you take action before it's too late",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Quibim",
        "url": "https://www.aixploria.com/out/Quibim",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/quibim.png",
        "description": "Analyze millions of medical images with unrivalled accuracy thanks to AI-enabled imaging biomarkers. Improved diagnosis and patient follow-up in over 170 healthcare institutions",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Neural Consult",
        "url": "https://www.aixploria.com/out/NeuralConsult",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/neural-consult.png",
        "description": "A host of AI tools to improve your skills in the medical sector: exam questions, Anki cards, clinical simulations, etc.",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "New Lantern",
        "url": "https://www.aixploria.com/out/NewLantern",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/new-lantern.png",
        "description": "A cloud solution for radiologists integrating automated AI tools to accurately analyze medical images. Ideal for speeding up patient diagnosis. Save up to 60 minutes per service",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Docus AI",
        "url": "https://www.aixploria.com/out/DocusAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/docus-ai.png",
        "description": "An AI assistant that looks after your health with personalized advice. Access also to the advice of renowned medical experts",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "HealthKey",
        "url": "https://www.aixploria.com/out/HealthKey",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/healthkey.png",
        "description": "An AI capable of summarizing medical records very quickly. Obtain patient histories in less than 90 seconds",
        "pricing": "Free Trial",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Heali AI",
        "url": "https://www.aixploria.com/out/HealiAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/heali-ai.png",
        "description": "An AI mobile application that offers personalized and therapeutic nutritional plans. The assistant adapts to your tastes and needs",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "OpenSynaps AI",
        "url": "https://opensynaps.com/en",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/opensynaps-ai.png",
        "description": "Find serenity and balance with sessions of hypnosis, sophrology and relaxation guided by an AI psychologist, available at any time. Take advantage of a caring community to improve your daily well-being",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Freudly AI Therapist",
        "url": "https://freudly.ai/",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/freudly-ai-therapist.png",
        "description": "Chat continuously with artificial intelligence specially designed for mental support and psychological listening. Conversations are geared toward understanding your emotions and helping you reflect on your personal life",
        "pricing": "Free Trial",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Ubie",
        "url": "https://www.aixploria.com/out/Ubie",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ubie.png",
        "description": "An AI healthcare assistant that quickly analyzes your symptoms and tries to identify potential causes",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Crosby Health",
        "url": "https://www.aixploria.com/out/CrosbyHealth",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/crosby-health.png",
        "description": "A complete solution for hospitals to generate, submit and track claims. This AI has been trained on millions of clinical cases",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Olyup",
        "url": "https://www.aixploria.com/out/Olyup",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/olyup.png",
        "description": "Optimize your athletic potential with an AI chatbot that monitors and improves your fitness goals. Real-time analysis and advice",
        "pricing": "Free Trial",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Leny AI",
        "url": "https://www.aixploria.com/out/LenyAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/04/website-icon-default.webp",
        "description": "A medical assistant (IA) who has great capabilities in the medical sector: analysis of symptoms, etc.",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Cradle",
        "url": "https://www.aixploria.com/out/Cradle",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/cradle.png",
        "description": "An AI-based aid for biologists who want to design proteins quickly and in an optimized way",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Hoku",
        "url": "https://www.aixploria.com/out/Hoku",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hoku.png",
        "description": "An AI health assistant that provides personalized health coaching, including meal and exercise plans",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "YourDoctor AI",
        "url": "https://www.aixploria.com/out/YourDoctorAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/yourdoctor-ai.png",
        "description": "Get health advice from an AI with some medical knowledge",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Skinive",
        "url": "https://www.aixploria.com/out/Skinive",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/skinive.png",
        "description": "An AI specialized in dermatology that detects diseases by analyzing your skin: cancer, herpes, acne, etc.",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "SymptomChecker IO",
        "url": "https://www.aixploria.com/out/SymptomCheckerIO",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/symptomchecker-io.png",
        "description": "From symptoms, get an online diagnosis. (not to be taken as real medical advice)",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Yesil Health",
        "url": "https://www.aixploria.com/out/YesilHealth",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/yesil-health.png",
        "description": "A personal health assistant who can answer your questions and analyze your symptoms",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Glass Health AI",
        "url": "https://www.aixploria.com/out/GlassHealthAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/glass-health-ai.png",
        "description": "An AI that helps medical professionals make a diagnosis based on symptoms",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Lunit AI",
        "url": "https://www.aixploria.com/out/LunitAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/02/favicon-defa.png",
        "description": "An AI that can detect cancers with 97-99% accuracy",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Ask Poppy",
        "url": "https://www.aixploria.com/out/AskPoppy",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ask-poppy.png",
        "description": "Poppy helps you in everyday life, he can also assist you if you are pregnant",
        "pricing": "Freemium",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Happy Mama",
        "url": "https://www.aixploria.com/out/HappyMama",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/happy-mama.png",
        "description": "Ask an artificial intelligence bot questions about your pregnancy and motherhood",
        "pricing": "Free",
        "categories": [
          "Healthcare"
        ]
      },
      {
        "name": "Lavo AI",
        "url": "https://www.aixploria.com/out/LavoAI",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/lavo-ai.png",
        "description": "Development of new tools and software by AI for the pharmaceutical and medical industry",
        "pricing": "Paid",
        "categories": [
          "Healthcare"
        ]
      }
    ]
  },
  {
    "category": "Writing & Web SEO",
    "tools": [
      {
        "name": "WriteHybrid AI Humanizer",
        "url": "https://aixplore.in/tool_details?slug=writehybrid-ai-humanizer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/writehybrid-ai-humanizer.png",
        "description": "AI that rewrites your texts to achieve a more fluid and natural style, adapted to human reading. This gives you content that is ready to be published, such as articles, reports, or long documents. Ability to work continuously on multiple texts",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rephrasy",
        "url": "https://aixplore.in/tool_details?slug=rephrasy",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rephrasy.png",
        "description": "This tool makes AI-generated texts undetectable by analysis systems such as GPTZero and Turnitin. This site can clone your writing style to create unique content",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Copy.ai",
        "url": "https://aixplore.in/tool_details?slug=copy-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/copy-ai.png",
        "description": "Editorial content generator for SEO, social networks and emails",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "HIX.AI",
        "url": "https://aixplore.in/tool_details?slug=hix-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hix-ai.png",
        "description": "A powerful AI writing assistant with over 120 tools. Create, search, rewrite and optimize content in over 50 languages for your editorial and marketing projects",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Balzac AI",
        "url": "https://aixplore.in/tool_details?slug=balzac-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/balzac-ai.png",
        "description": "A powerful AI copywriting agent to automatically generate high-quality SEO articles, plan their publication and quickly improve your online visibility. Multiple language support",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Chapple AI",
        "url": "https://aixplore.in/tool_details?slug=chapple-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/02/chapple-ai.png",
        "description": "A set of AI tools for rapidly generating all kinds of creative content: text, images, audio, programming code and more",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Koala AI",
        "url": "https://aixplore.in/tool_details?slug=koala-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/05/favicon-32x32-1.png",
        "description": "Write SEO-optimized articles in minutes with GPT-5 and Claude 4 with real-time SERP analysis. Enjoy bulk article generation, automatic internal links, schema markup, and a full suite of tools (chat, images, links) in a single subscription.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Pismo.ai",
        "url": "https://aixplore.in/tool_details?slug=pismo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pismo-ai.png",
        "description": "An AI writing assistant for your computer. It works anywhere, uses hotkeys for instant help, fixes errors, adjusts tone, and costs less than ChatGPT",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Clico",
        "url": "https://aixplore.in/tool_details?slug=clico",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/04/clico_logo.webp",
        "description": "This AI assistant integrates into every text field in your browser (Gmail, Notion, Slack, LinkedIn, etc.) to help you write, reply, rephrase, or dictate instantly. You stay in the same context without switching tabs or copying and pasting. Available via a Chrome extension",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "FlashPaper",
        "url": "https://aixplore.in/tool_details?slug=flashpaper",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/flashpaper.png",
        "description": "A powerful AI writing tool for researchers and students to chat with PDF files, generate topics and outlines, generate text, paraphrase, detect plagiarism & cite \u2013 all in one",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WordAI",
        "url": "https://aixplore.in/tool_details?slug=wordai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wordai.png",
        "description": "Rewrite your text with professional quality. Let AI suggest changes and improve your writing style",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Go Humanize AI",
        "url": "https://aixplore.in/tool_details?slug=go-humanize-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/go-humanize-ai.png",
        "description": "This tool analyzes and rewrites AI-generated text to give it a natural, fluid, and human-like style. Make your AI text undetectable by ZeroGPT, GPTZero, Originality.ai, or Turnitin using a rewriter that transforms robotic-sounding text into natural language",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Textbuddy",
        "url": "https://aixplore.in/tool_details?slug=textbuddy",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/textbuddy.png",
        "description": "Intelligent tool that analyzes your text to improve and simplify your writing",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "SEO.ai",
        "url": "https://aixplore.in/tool_details?slug=seo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/seo-ai.png",
        "description": "Quickly create quality, high-performance SEO content. Available in over 50 languages",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Juice AI",
        "url": "https://aixplore.in/tool_details?slug=juice-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/juice-ai.png",
        "description": "An AI specialized in marketing content creation: SEO text generation, keywords, etc.",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Moji",
        "url": "https://aixplore.in/tool_details?slug=moji",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/moji.png",
        "description": "A multi-tasking AI assistant: writing, email, code, keyword and image generation. Available on IOS",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Jaq n Jil",
        "url": "https://aixplore.in/tool_details?slug=jaq-n-jil",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/jaq-n-jil.png",
        "description": "An AI-based writing assistant for SEO and marketing content writing",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Adwrite",
        "url": "https://aixplore.in/tool_details?slug=adwrite",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/04/website-icon-default.webp",
        "description": "A copywriting assistant specialized in editorial content: SEO, marketing, E-commerce, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "StoryLab AI",
        "url": "https://aixplore.in/tool_details?slug=storylab-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/storylab-ai.png",
        "description": "An AI that generates content ideas, hooks and plans to improve your writing",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Auri AI",
        "url": "https://aixplore.in/tool_details?slug=auri-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/auri-ai.png",
        "description": "An AI writing assistant offering spelling correction, paraphrasing, translation and text generation",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Articly",
        "url": "https://aixplore.in/tool_details?slug=articly",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/articly.png",
        "description": "Creation of articles, with an AI co-pilot, optimized for search engines (SEO)",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Relume Ipsum",
        "url": "https://aixplore.in/tool_details?slug=relume-ipsum",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/relume-ipsum.png",
        "description": "An AI-assisted writing tool for designers. Allows you to quickly generate text without leaving Figma",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Jounce",
        "url": "https://aixplore.in/tool_details?slug=jounce",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/jounce.png",
        "description": "AI solution that helps you write your texts. Create copywrting content very quickly",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Keywrds AI",
        "url": "https://aixplore.in/tool_details?slug=keywrds-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/keywrds-ai.png",
        "description": "Use AI to generate keywords, find niches and SEO topics relevant to your audience",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rewriter AI",
        "url": "https://aixplore.in/tool_details?slug=rewriter-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/02/favicon-defa.png",
        "description": "Reduce your writing time with AI: rephrasing, paraphrasing, grammar and text summary",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Newswriter AI",
        "url": "https://aixplore.in/tool_details?slug=newswriter-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/newswriter-ai.png",
        "description": "An AI assistant for writing press releases in GPT-3",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "BlogSEO AI",
        "url": "https://aixplore.in/tool_details?slug=blogseo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/blogseo-ai.png",
        "description": "Create SEO-friendly blog posts with the help of AI. Improve your blog, find new targeted keywords and stay on top of SERPs",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Yaara AI",
        "url": "https://aixplore.in/tool_details?slug=yaara-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/yaara-ai.png",
        "description": "Textual content generator that also has the ability to improve your grammar and vocabulary",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Loyae",
        "url": "https://aixplore.in/tool_details?slug=loyae",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/loyae.png",
        "description": "An AI application that helps you improve your website's search engine optimization (SEO). Makes your site more visible and attractive",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "EasySEO.ai",
        "url": "https://aixplore.in/tool_details?slug=easyseo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/04/website-icon-default.webp",
        "description": "Help yourself to an intelligent writing assistant, capable of creating unique, SEO-optimized content",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "CTRify",
        "url": "https://aixplore.in/tool_details?slug=ctrify",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ctrify.png",
        "description": "An AI-based SEO platform to improve your websites ranking. Also helps to increase your organic traffic",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Remagine AI",
        "url": "https://aixplore.in/tool_details?slug=remagine-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/remagine-ai.png",
        "description": "Boost your content creation with the help of over 150 AI templates and tools. Take advantage of personalized suggestions and grammatical corrections",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Trolly.ai",
        "url": "https://aixplore.in/tool_details?slug=trolly-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/trolly-ai.png",
        "description": "A collection of tools to help you write SEO articles faster. Available in 20 languages",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Autowrite App",
        "url": "https://aixplore.in/tool_details?slug=autowrite-app",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/autowrite-app.png",
        "description": "An AI writing assistant that helps businesses increase traffic, SEO and sales",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WriteSmart",
        "url": "https://aixplore.in/tool_details?slug=writesmart",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/writesmart.png",
        "description": "An AI that helps you write engaging responses and comments on LinkedIn posts",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Article Fiesta",
        "url": "https://aixplore.in/tool_details?slug=article-fiesta",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/article-fiesta.png",
        "description": "An SEO article generator capable of generating high quality paragraphs from a few keywords",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "EssayService AI",
        "url": "https://aixplore.in/tool_details?slug=essayservice-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/essayservice-ai.png",
        "description": "A tool for writing essays with an intelligent understanding of subjects: thesis formulation, grammar improvement, plagiarism detection, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "AI Magicx",
        "url": "https://aixplore.in/tool_details?slug=ai-magicx",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-magicx.png",
        "description": "Generate SEO articles and copywriting content with the help of AI. Over 75 templates available for ChatGPT 4 Turbo and Claude v2",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Strut",
        "url": "https://aixplore.in/tool_details?slug=strut",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/strut.png",
        "description": "A collaborative workspace dedicated to writers: better organisation, real-time collaboration and the creation of high-quality content by AI",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "BlogFox",
        "url": "https://aixplore.in/tool_details?slug=blogfox",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/blogfox.png",
        "description": "Turn your YouTube videos into SEO-optimized blog posts with an AI tool that makes effective use of Anthropic's Claude Opus",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "FigGPT",
        "url": "https://aixplore.in/tool_details?slug=figgpt",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/figgpt.png",
        "description": "Boost your productivity in Figma with this AI-powered plugin. A multilingual tool specializing in text writing and editing",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Junia AI",
        "url": "https://aixplore.in/tool_details?slug=junia-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/junia-ai.png",
        "description": "A content generator optimised by AI for search engines (SEO), expert in writing even very long articles",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Wikipedia Article AI",
        "url": "https://aixplore.in/tool_details?slug=wikipedia-article-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wikipedia-article-ai.png",
        "description": "Create a Wikipedia page in just a few seconds with AI. Generate factual content that respects the rules imposed by Wikipedia",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Seo Review Tools",
        "url": "https://aixplore.in/tool_details?slug=seo-review-tools",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/seo-review-tools.png",
        "description": "A multitude of tools (66+) under AI to maximize and deeply optimize your SEO in real time",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rephraser.co",
        "url": "https://aixplore.in/tool_details?slug=rephraser-co",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rephraser-co.png",
        "description": "Reformulate your texts without losing their original meaning. Ideal for researchers, students and marketing professionals",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Cowriter",
        "url": "https://aixplore.in/tool_details?slug=cowriter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/cowriter.png",
        "description": "An AI capable of writing articles or essays very quickly via an intuitive interface",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "AI Cowriter",
        "url": "https://aixplore.in/tool_details?slug=ai-cowriter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-cowriter.png",
        "description": "A powerful writing assistant to improve your writing style. Also features real-time autocomplete suggestions",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "SEO GPT",
        "url": "https://aixplore.in/tool_details?slug=seo-gpt",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/seo-gpt.png",
        "description": "Free content generator based on GPT-3 to produce SEO optimized texts",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Textero AI",
        "url": "https://aixplore.in/tool_details?slug=textero-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/textero-ai.png",
        "description": "An academic level writing assistant. Ideal for your school essays or article writing",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "LongShot",
        "url": "https://aixplore.in/tool_details?slug=longshot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/longshot.png",
        "description": "Create unique content for your blog in minutes",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Multiblog AI",
        "url": "https://aixplore.in/tool_details?slug=multiblog-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/multiblog-ai.png",
        "description": "A multilingual content generator for websites. Create SEO-optimized articles in 50 languages, manage several blogs simultaneously and publish directly to WordPress or other CMS",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Bypassgpt",
        "url": "https://aixplore.in/tool_details?slug=bypassgpt",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/bypassgpt.png",
        "description": "An AI content rewriting tool to make your text undetectable by AI detection systems. Crucial for SEO and avoiding plagiarism",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "NeuroSpell",
        "url": "https://aixplore.in/tool_details?slug=neurospell",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/neurospell.png",
        "description": "Spell and grammar checker available in over 30 languages",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "SpinBot",
        "url": "https://aixplore.in/tool_details?slug=spinbot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/spinbot.png",
        "description": "Submit a text or an article to him, he makes a new one",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Expert Pitch",
        "url": "https://aixplore.in/tool_details?slug=expert-pitch",
        "icon": "https://www.aixploria.com/wp-content/uploads/2026/03/favicon.png",
        "description": "This AI-powered PR assistant analyzes journalists' requests every day and automatically sends personalized pitches on your behalf. Ideal for getting high-quality backlinks and improving your SEO",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "TextFX by Google",
        "url": "https://aixplore.in/tool_details?slug=textfx-by-google",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/textfx-by-google.png",
        "description": "A set of 10 writing tools specialising in creative content. The site works using Google's PaLM 2 model",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "BlogNLP",
        "url": "https://aixplore.in/tool_details?slug=blognlp",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/blognlp.png",
        "description": "An easy-to-use text or article generator designed specifically for blogs and websites",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Aithor",
        "url": "https://aixplore.in/tool_details?slug=aithor",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/aithor.png",
        "description": "A multilingual AI writing assistant that generates essays and articles. It features a search tool and suggested outlines to facilitate academic writing",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "AI Paraphrasing Tool",
        "url": "https://aixplore.in/tool_details?slug=ai-paraphrasing-tool",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-paraphrasing-tool.png",
        "description": "Simplify your writing with this paraphrasing tool that reformulates your content at different levels: sentences, phrases and paragraphs",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WordTune",
        "url": "https://aixplore.in/tool_details?slug=wordtune",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wordtune.png",
        "description": "Refine and perfect your writing to make it SEO friendly",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Corrector App",
        "url": "https://aixplore.in/tool_details?slug=corrector-app",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/corrector-app.png",
        "description": "Quickly check your text with this AI-powered spell checker",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Samwell",
        "url": "https://aixplore.in/tool_details?slug=samwell",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/samwell.png",
        "description": "An AI that generates articles, essays or papers while checking if the content is authentic (plagiarism)",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WriteText.ai",
        "url": "https://aixplore.in/tool_details?slug=writetext-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/writetext-ai.png",
        "description": "A writing assistant specially developed for WooCommerce. It can create product descriptions and SEO content very quickly",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "StudyCrumb",
        "url": "https://aixplore.in/tool_details?slug=studycrumb",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/studycrumb.png",
        "description": "Rephrase your sentences quickly and easily with this expert paraphrasing tool",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Magic Type AI",
        "url": "https://aixplore.in/tool_details?slug=magic-type-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/magic-type-ai.png",
        "description": "A text generator that writes poems, lyrics and even rap",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WriteHuman",
        "url": "https://aixplore.in/tool_details?slug=writehuman",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/writehuman.png",
        "description": "Transform AI-generated text into undetectable human handwriting. Avoid detection of your AI content",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WriteMe",
        "url": "https://aixplore.in/tool_details?slug=writeme",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/writeme.png",
        "description": "An AI-based writing assistant for creating high-quality textual content. Available in around 20 languages",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Essay Builder AI",
        "url": "https://aixplore.in/tool_details?slug=essay-builder-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/essay-builder-ai.png",
        "description": "A text generator specifically designed to help students with their academic writing and exercises",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Better Synonyms AI",
        "url": "https://aixplore.in/tool_details?slug=better-synonyms-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/better-synonyms-ai.png",
        "description": "A handy AI tool that can find synonyms in less than a second",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Monica",
        "url": "https://aixplore.in/tool_details?slug=monica",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/monica.png",
        "description": "A Chrome extension for ChatGPT that can translate, summarize, write your emails, generate text, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "RivalFlow AI",
        "url": "https://aixplore.in/tool_details?slug=rivalflow-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rivalflow-ai.png",
        "description": "Improve your existing content and fill your SEO gaps with AI-optimised content suggestions",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Fixkey AI",
        "url": "https://aixplore.in/tool_details?slug=fixkey-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/fixkey-ai.png",
        "description": "An AI writing assistant that works in real time at the speed of your writing. Corrections or suggestions are instantaneous. Available on macOS",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Scribens",
        "url": "https://aixplore.in/tool_details?slug=scribens",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/scribens.png",
        "description": "A spell checker that checks your mistakes in any text",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Cordial",
        "url": "https://aixplore.in/tool_details?slug=cordial",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/cordial.png",
        "description": "An AI that corrects your text and highlights your spelling mistakes (in French only)",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Copymatic",
        "url": "https://aixplore.in/tool_details?slug=copymatic",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/copymatic.png",
        "description": "Boost your traffic with this quality SEO content generator",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "CreativAI",
        "url": "https://aixplore.in/tool_details?slug=creativai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/creativai.png",
        "description": "A multi-tasking writing assistant that can write and improve your emails, ads, articles, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Jack AI",
        "url": "https://aixplore.in/tool_details?slug=jack-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/jack-ai.png",
        "description": "A copywriting assistant entirely dedicated to marketing development. Generate, improve and refine your content in no time at all",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Redense AI",
        "url": "https://aixplore.in/tool_details?slug=redense-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/redense-ai.png",
        "description": "Simplifies and accelerates the creation of newsletters: generates relevant titles, automates writing, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Scribble AI",
        "url": "https://aixplore.in/tool_details?slug=scribble-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/scribble-ai.png",
        "description": "Automatic text generation for different content types with custom styling options",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Hemingway App",
        "url": "https://aixplore.in/tool_details?slug=hemingway-app",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hemingway-app.png",
        "description": "An AI that helps you write original texts. Also checks your spelling and grammar",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Multilings",
        "url": "https://aixplore.in/tool_details?slug=multilings",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/multilings.png",
        "description": "A multi-tasking AI tool specializing in copywriting, plagiarism detection and language translation. Easy-to-use interface",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "SEOBox.ai",
        "url": "https://aixplore.in/tool_details?slug=seobox-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2023/04/website-icon-default.webp",
        "description": "Receive personalized guidelines for your backlinks. The AI is inspired by your keywords or by what it deems relevant for your SEO",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Flot.ai",
        "url": "https://aixplore.in/tool_details?slug=flot-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/flot-ai.png",
        "description": "A GPT-4 co-pilot that integrates seamlessly into your applications or websites. Options: copywriting, paraphrasing, grammar correction, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "ContentPie",
        "url": "https://aixplore.in/tool_details?slug=contentpie",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/contentpie.png",
        "description": "Generate SEO-optimized content easily with AI. Get article ideas, images and publish everything directly on your site",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Buni AI",
        "url": "https://aixplore.in/tool_details?slug=buni-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/buni-ai.png",
        "description": "Create high-quality content in minutes with text, image and code generation tools",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Eye2.ai",
        "url": "https://aixplore.in/tool_details?slug=eye2-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/eye2-ai.png",
        "description": "Benefit from an online service that combines artificial intelligence and human expertise to precisely refine and humanize your content",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WordfixerBot",
        "url": "https://aixplore.in/tool_details?slug=wordfixerbot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wordfixerbot.png",
        "description": "AI writing assistant for paraphrasing, grammar checking, text summarization, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "ThunderContent",
        "url": "https://aixplore.in/tool_details?slug=thundercontent",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/thundercontent.png",
        "description": "Writing tool specialized in writing articles",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rizz! Keyboard",
        "url": "https://aixplore.in/tool_details?slug=rizz-keyboard",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rizz--keyboard.png",
        "description": "An AI designed for writing short texts: emails, texts, messages for social networks, etc.",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Machined.ai",
        "url": "https://aixplore.in/tool_details?slug=machined-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/machined-ai.png",
        "description": "An AI-based multilingual text generator, specialized in SEO article writing. Possibility of using GPT 3.5 or GPT 4",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Shakespeare",
        "url": "https://aixplore.in/tool_details?slug=shakespeare",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/shakespeare.png",
        "description": "An AI-driven writer who can write text-based content for marketing and advertising campaigns",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Surfer Seo",
        "url": "https://aixplore.in/tool_details?slug=surfer-seo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/surfer-seo.png",
        "description": "An AI-powered tool that analyzes and optimizes your content (SEO). Improve your Google ranking thanks to your competitors",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Great Headlines",
        "url": "https://aixplore.in/tool_details?slug=great-headlines",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/great-headlines.png",
        "description": "AI that generates catchy headlines in seconds, ideal for marketers and copywriters",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Squirrly SEO",
        "url": "https://aixplore.in/tool_details?slug=squirrly-seo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/squirrly-seo.png",
        "description": "A complete suite of AI-powered SEO tools that help optimize content and increase traffic",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Copymate",
        "url": "https://aixplore.in/tool_details?slug=copymate",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/copymate.png",
        "description": "An AI-powered SEO content generator that can quickly create optimized articles in multiple languages",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Text Generator",
        "url": "https://aixplore.in/tool_details?slug=text-generator",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/text-generator.png",
        "description": "High quality, multilingual AI text generator. You get 100 free requests per month",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "SchoolHack",
        "url": "https://aixplore.in/tool_details?slug=schoolhack",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/schoolhack.png",
        "description": "A versatile mobile app for students: writing assistant, essays, summaries, Q&A, etc.",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Sentence Rewriter",
        "url": "https://aixplore.in/tool_details?slug=sentence-rewriter",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sentence-rewriter.png",
        "description": "Automatically rewrite your sentences for greater clarity. Instantly paraphrase your texts using formal/informal modes, tone enhancement, and readability improvement",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Ginger AI",
        "url": "https://aixplore.in/tool_details?slug=ginger-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ginger-ai.png",
        "description": "Improve your writing with this high-quality AI assistant. Correct your texts, refine your style and stimulate your creativity with intelligent contextual suggestions",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Peppertype.ai",
        "url": "https://aixplore.in/tool_details?slug=peppertype-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/peppertype-ai.png",
        "description": "A virtual assistant that helps you create quality editorial content",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Grimo AI",
        "url": "https://aixplore.in/tool_details?slug=grimo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/04/grimo-favicon-update.png",
        "description": "Express your ideas without limits via a hyper-intelligent text editor that facilitates collaboration and boosts productivity. Ideal for demanding professionals.",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Sequens.ai",
        "url": "https://aixplore.in/tool_details?slug=sequens-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/sequens-ai.png",
        "description": "Create large-scale marketing content with AI. Generate SEO blog posts, targeted publications for social networks, scripts to increase your leads.. \u27a5 Supervised by B2B experts",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "PairOkay",
        "url": "https://aixplore.in/tool_details?slug=pairokay",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/pairokay.png",
        "description": "Easy-to-use SEO copywriting assistant",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Safenew AI",
        "url": "https://aixplore.in/tool_details?slug=safenew-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/safenew-ai.png",
        "description": "Turn your AI-generated texts into natural writing, just like a human would write. The AI keeps the meaning and intent of your texts. Presented as undetectable by detection software",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Wordbrew",
        "url": "https://aixplore.in/tool_details?slug=wordbrew",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wordbrew.png",
        "description": "A powerful AI tool to optimize your writing. Create better content, improve your style, and quickly increase your productivity. Also includes a collaborative system",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "AI Article Writer 6.0",
        "url": "https://aixplore.in/tool_details?slug=ai-article-writer-6-0",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-article-writer-6-0.png",
        "description": "Generate accurate, SEO-optimized articles in minutes. Includes web search, semantic analysis, internal links and citations",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Wordhero",
        "url": "https://aixplore.in/tool_details?slug=wordhero",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/wordhero.png",
        "description": "Content generation for social networks, emails and more",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "NeuralText",
        "url": "https://aixplore.in/tool_details?slug=neuraltext",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/neuraltext.png",
        "description": "Automate your writing and text creation with an AI expert in SEO",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rayo",
        "url": "https://aixplore.in/tool_details?slug=rayo",
        "icon": "https://www.aixploria.com/wp-content/uploads/2025/08/rayo-favicon.png",
        "description": "Rayo is built for SEO teams and individuals who want to generate insight-packed blogs with natural flair and variation only humans can write",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Grammar Checker",
        "url": "https://aixplore.in/tool_details?slug=grammar-checker",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/grammar-checker.png",
        "description": "Instantly correct all grammar, punctuation, and spelling mistakes using advanced AI technology to improve your writing. Perfect for helping you communicate more professionally",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "InkForAll",
        "url": "https://aixplore.in/tool_details?slug=inkforall",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/inkforall.png",
        "description": "Help in writing content focused on SEO",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Botowski",
        "url": "https://aixplore.in/tool_details?slug=botowski",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/botowski.png",
        "description": "A writing assistant who knows all the SEO techniques (copywriter)",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "AI Lab",
        "url": "https://aixplore.in/tool_details?slug=ai-lab",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/ai-lab.png",
        "description": "Suggest texts from an idea, help you to write without spelling mistakes.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Deepl Write",
        "url": "https://aixplore.in/tool_details?slug=deepl-write",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/deepl-write.png",
        "description": "Improve your English writing with Deepl's new AI tool, which makes it easy to correct spelling mistakes, find synonyms and more",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Dageno AI",
        "url": "https://aixplore.in/tool_details?slug=dageno-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dageno-ai.png",
        "description": "Analyze how your brand appears in responses from ChatGPT, Perplexity, Gemini, and other AI systems, then boost your visibility with GEO + SEO recommendations. The platform analyzes mentions, citations, traffic, backlinks, and sentiment to turn your data into concrete marketing actions",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Koke AI",
        "url": "https://aixplore.in/tool_details?slug=koke-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/koke-ai.png",
        "description": "Save time in your work with multi-agent AI that generates citations (APA, MLA, IEEE, Chicago, etc.), creates personalized outlines, summarizes sources, and centralizes your references to facilitate academic writing",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Analogenie",
        "url": "https://aixplore.in/tool_details?slug=analogenie",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/analogenie.png",
        "description": "Use AI to explain complex concepts using easy-to-understand analogies",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Moonbeam",
        "url": "https://aixplore.in/tool_details?slug=moonbeam",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/moonbeam.png",
        "description": "An automatic AI writer specialized in long essays",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "TextGo AI",
        "url": "https://aixplore.in/tool_details?slug=textgo-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/textgo-ai.png",
        "description": "A tool that makes AI-generated texts undetectable by detection systems. Humanize your content so that it passes authenticity tests with a high success rate",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Scalenut",
        "url": "https://aixplore.in/tool_details?slug=scalenut",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/scalenut.png",
        "description": "An AI platform that simplifies SEO content creation. Generate optimized articles in minutes with intelligent tools",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "LanguageTool",
        "url": "https://aixplore.in/tool_details?slug=languagetool",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/languagetool.png",
        "description": "A multilingual AI writing assistant to improve your texts. Correct grammar, spelling and style in over 30 languages with browser and desktop application extensions",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Prism OpenAI",
        "url": "https://aixplore.in/tool_details?slug=prism-openai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/prism-openai.png",
        "description": "A free cloud-based LaTeX workspace that directly integrates GPT-5.2 into scientific writing, with unlimited projects and collaborators. Instantly convert your whiteboard sketches into LaTeX code, search arXiv documentation, add automatic citations, and more",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Smodin",
        "url": "https://aixplore.in/tool_details?slug=smodin",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/smodin.png",
        "description": "A powerful content writer, ideal for students",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rehumanize.io",
        "url": "https://aixplore.in/tool_details?slug=rehumanize-io",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rehumanize-io.png",
        "description": "Paste your AI-generated text (ChatGPT, Claude) and the tool will instantly rewrite it to give it a more natural style, without changing the meaning. It bypasses the main AI detectors and supports documents of up to 50,000 words at a time",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Paraphrasing Tool",
        "url": "https://aixplore.in/tool_details?slug=paraphrasing-tool",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/paraphrasing-tool.png",
        "description": "This AI assistant creates and translates texts, with integrated search and paraphrase functions",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Copyleaks",
        "url": "https://aixplore.in/tool_details?slug=copyleaks",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/copyleaks.png",
        "description": "A plagiarism detection platform to check that your content is 100% unique. Available API integration",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Decopy AI",
        "url": "https://aixplore.in/tool_details?slug=decopy-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/decopy-ai.png",
        "description": "Detect, humanize, and optimize your AI texts with a set of AI tools to create original, natural, and impactful content. Also features tools such as YouTube Video Summarizer or AI Math Solver",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Video To Blog",
        "url": "https://aixplore.in/tool_details?slug=video-to-blog",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/video-to-blog.png",
        "description": "From a YouTube URL, you can convert any video into an SEO blog post. Export as HTML, TXT, PDF, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "HyperWrite AI",
        "url": "https://aixplore.in/tool_details?slug=hyperwrite-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/hyperwrite-ai.png",
        "description": "Generate textual content with a writing AI assistant from a Chrome extension",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Frase IO",
        "url": "https://aixplore.in/tool_details?slug=frase-io",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/frase-io.png",
        "description": "Optimize your SEO content with AI that analyzes SERPs, researches keywords, generates plans, writes articles and more. Compare yourself to your competitors with easy-to-use, highly effective tools",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Humanizer-AI-Text",
        "url": "https://aixplore.in/tool_details?slug=humanizer-ai-text",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/humanizer-ai-text.png",
        "description": "A platform that makes AI-generated texts undetectable by analysis systems. Modify style, structure and vocabulary while preserving the original message of your content",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Search Atlas",
        "url": "https://aixplore.in/tool_details?slug=search-atlas",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/search-atlas.png",
        "description": "Fully automate your SEO strategy with OTTO, an AI that optimizes content, manages Google Ads campaigns, monitors local positions and generates customer reports. Centralize technical auditing, competitive research, article creation and netlinking",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "SciSpace AI Writer",
        "url": "https://aixplore.in/tool_details?slug=scispace-ai-writer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/scispace-ai-writer.png",
        "description": "This high-performance research assistant is equipped with a powerful AI feature to help with writing. Create scientific content with built-in citations, precise auto-completion and support for over 75 languages",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "QuillBot",
        "url": "https://aixplore.in/tool_details?slug=quillbot",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/quillbot.png",
        "description": "A practical tool for quickly rewriting, checking and improving your texts. Available options: paraphrase, grammar, translation, plagiarism, etc.",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Undetectable AI",
        "url": "https://aixplore.in/tool_details?slug=undetectable-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/undetectable-ai.png",
        "description": "Make your AI-generated texts undetectable by humanizing them. Ideal for students, SEO copywriters, journalists, etc.",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Semrush Content Toolkit",
        "url": "https://aixplore.in/tool_details?slug=semrush-content-toolkit",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/contentshake-ai.png",
        "description": "Powerful AI tools for easy generation of SEO-optimized content. Find ideas, write articles and publish them directly on your blog or website",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Free AI Content Writer",
        "url": "https://aixplore.in/tool_details?slug=free-ai-content-writer",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/04/HubSpot-fav.png",
        "description": "Create impactful content instantly with an AI assistant developed by HubSpot. Generate SEO articles, social media posts or e-mails adapted to your brand and audience",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rytr",
        "url": "https://aixplore.in/tool_details?slug=rytr",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rytr.png",
        "description": "An intelligent copywriting assistant to help you create high-quality content",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "GPTZero",
        "url": "https://aixplore.in/tool_details?slug=gptzero",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/gptzero.png",
        "description": "Detect content generated by ChatGPT, GPT-5, Gemini, Claude, and other LLMs with high accuracy using multi-factor analysis and sentence-by-sentence highlighting. Discover the Writing Report: proof that your text is human-written",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "WriteSonic",
        "url": "https://aixplore.in/tool_details?slug=writesonic",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/writesonic.png",
        "description": "A text generator specially designed to create SEO-optimized articles. Possibility of using different models via a chatbot",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Semrush SEO Toolkit",
        "url": "https://aixplore.in/tool_details?slug=semrush-seo-toolkit",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/semrush.png",
        "description": "Optimize your SEO and marketing with an AI-enhanced suite of tools. Benefit from an integrated virtual assistant, search for keywords, generate optimized content and analyze your data with intelligent algorithms",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Clever AI Humanizer",
        "url": "https://aixplore.in/tool_details?slug=clever-ai-humanizer",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/clever-ai-humanizer.png",
        "description": "Pass under the radar of AI detectors. This tool transforms any robotic text into more human, fluid, and natural content, as if it came from you. Your secret is safe with us",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Jasper",
        "url": "https://aixplore.in/tool_details?slug=jasper",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/jasper.png",
        "description": "One of the best SEO optimized text generators with a chatbot in beta version",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Storm",
        "url": "https://aixplore.in/tool_details?slug=storm",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/storm.png",
        "description": "A research assistant that writes Wikipedia-style articles from verified web sources. Ask questions, explore different perspectives and collaborate with AI agents to create structured, documented content",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Free AI Content Assistant",
        "url": "https://aixplore.in/tool_details?slug=free-ai-content-assistant",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/04/HubSpot-fav.png",
        "description": "Write catchier, higher-quality content with an expert copywriting AI assistant. It can generate SEO blog articles, social network posts, e-mail marketing and more",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Blog Ideas Generator",
        "url": "https://aixplore.in/tool_details?slug=blog-ideas-generator",
        "icon": "https://www.aixploria.com/wp-content/uploads/2024/04/HubSpot-fav.png",
        "description": "Instantly generate relevant, SEO-optimized blog ideas with HubSpot's AI. Quickly create catchy titles and post outlines",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Optimo",
        "url": "https://aixplore.in/tool_details?slug=optimo",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/optimo.png",
        "description": "Free and complete marketing tools with AI for: SEO, Instagram, copywriting, video, email, etc.",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Humanizer AI",
        "url": "https://aixplore.in/tool_details?slug=humanizer-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/humanizer-ai.png",
        "description": "An AI tool that refines AI-generated text into human-like writing, with features like shortening, expansion, and a \"Human Score\" to ensure it bypasses AI detectors",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Text Cortex",
        "url": "https://aixplore.in/tool_details?slug=text-cortex",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/text-cortex.png",
        "description": "A set of AI tools dedicated to writing, fully customizable. This AI can adapt to your writing style for even greater relevance",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Grammarly",
        "url": "https://aixplore.in/tool_details?slug=grammarly",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/grammarly.png",
        "description": "Write original, high-quality content. Get advice from an AI-driven writing assistant",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Paperpal",
        "url": "https://aixplore.in/tool_details?slug=paperpal",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/paperpal.png",
        "description": "An AI writing tool for researchers to paraphrase, check grammar, fix fluency, detect plagiarism & cite\u2014all in one. Works on web, Google Docs & Word",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Symplified",
        "url": "https://aixplore.in/tool_details?slug=symplified",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/symplified.png",
        "description": "A multi-tasking AI that can generate text, video and images",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Rankin AI",
        "url": "https://aixplore.in/tool_details?slug=rankin-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/rankin-ai.png",
        "description": "An AI tool that shows you where your content appears in AI-generated search results and tells you how to improve your visibility and ranking on these platforms (ChatGPT, Gemini, Perplexity, etc.)",
        "pricing": "Freemium",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Dechecker",
        "url": "https://aixplore.in/tool_details?slug=dechecker",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/dechecker.png",
        "description": "A text checker that analyzes writing style to identify passages that may have been automatically generated by AI and helps you make your writing more natural and credible",
        "pricing": "Free",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Typli.ai",
        "url": "https://aixplore.in/tool_details?slug=typli-ai",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/typli-ai.png",
        "description": "Use over 180 tools to generate texts, letters, emails, summaries, or product descriptions. This powerful platform also includes features for rephrasing, structuring long content, and creating images",
        "pricing": "Paid",
        "categories": [
          "Writing & Web SEO"
        ]
      },
      {
        "name": "Yozo AI SEO Blogs",
        "url": "https://aixplore.in/tool_details?slug=yozo-ai-seo-blogs",
        "icon": "https://www.aixploria.com/wp-content/uploads/favicons/yozo-ai-seo-blogs.png",
        "description": "Generate human-like, SEO-optimized blogs at scale to rank your store faster on Google and boost organic traffic",
        "pricing": "Free Trial",
        "categories": [
          "Writing & Web SEO"
        ]
      }
    ]
  }
];
